export default {
  openapi: "3.0.0",

  servers: [
    {
      description: "mea API",
      url: `${process.env.REACT_APP_API_URL}`,
    },
  ],
  tags: [
    { name: "ข้อมูลแผนที่ฐาน" },
    {
      name: "ข้อมูลระบบไฟฟ้า"
    },
    {
      name: "Premium Service"
    }  
    

  ],
  paths: {
    "/v1.0/collections/landmark-points/items": {
      get: {
        tags: ["ข้อมูลแผนที่ฐาน"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สถานที่สำคัญ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.road_name:ถนนส.หทัยราษฎร์",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
              example: 1,
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              branch_e: {
                                type: "string",
                              },
                              branch_t: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              lb_status: {
                                type: "string",
                              },
                              location: {
                                type: "string",
                              },
                              location_e: {
                                type: "string",
                              },
                              master: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nick_name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              road_name: {
                                type: "string",
                              },
                              scale: {
                                type: "string",
                              },
                              sub_group: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "string",
                              },
                              work_function: {
                                type: "string",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.91216961,
                            13.92677222
                          ]
                        },
                        "properties": {
                          "_id": "60869177b5d5430316ae3f49",
                          "branch_e": "",
                          "branch_t": "",
                          "creation_user": "",
                          "data_name": "",
                          "date_created": null,
                          "date_modified": null,
                          "design_id": "",
                          "geohash": "w4rz0r3crf",
                          "global_id": "{EF4C3B1B-BCB1-4B43-9F26-EEE03E19B3BA}",
                          "last_user": "",
                          "lb_status": "P",
                          "location": "โรงเรียนคลองสิบสี่",
                          "location_e": "",
                          "master": "",
                          "name": "โรงเรียนคลองสิบสี่",
                          "nick_name": "",
                          "object_id": 2,
                          "road_name": "ถนนส.หทัยราษฎร์",
                          "scale": null,
                          "sub_group": 1,
                          "sub_type_code": 1101,
                          "symbol_rotation": 90,
                          "tag": "330000000616881",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }
                }
              }
            }
          }
        }
      }
    },
    "/v1.0/collections/district-polys/items": {
      get: {
        tags: ["ข้อมูลแผนที่ฐาน"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "เส้นขอบเขตการไฟฟ้าเขต",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.name_t:การไฟฟ้าเขตสมุทรปราการ",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box]( http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              lb_status: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              work_flow_status: {
                                type: "string",
                              },
                              work_function: {
                                type: "string",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "Polygon",
                          coordinates: [
                            [
                              [100.57021339, 13.66043963],
                              [100.56953631, 13.65991625],
                              [100.5686647, 13.65924269],
                              [100.56729075, 13.65826158],
                              [100.56669698, 13.65784162],
                              [100.56609955, 13.65748043],
                              [100.56553885, 13.65717098],
                              [100.56540436, 13.65710065],
                              [100.56514178, 13.65696785],
                              [100.56490821, 13.6568552],
                              [100.56483926, 13.65682287],
                            ],
                          ],
                        },
                        properties: {
                          _id: "5e99acf5b51c368d2cf6f001",
                          creation_user: "mea2071322",
                          date_created: "2012-01-04T17:00:00Z",
                          date_modified: "2016-07-28T02:24:55Z",
                          design_id: " ",
                          geohash: "w4rt8wbczf",
                          id_code: 77,
                          last_user: "Coop3101700278669",
                          name: "Samut Prakarn District",
                          name_code_e: "SPD.",
                          name_code_t: "ฟขป.",
                          name_e: "Samut Prakarn District",
                          name_t: "การไฟฟ้าเขตสมุทรปราการ",
                          object_id: 403,
                          work_flow_status: 0,
                          work_function: 0,
                          work_location_id: " ",
                          work_request_id: " ",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/landmark-lines/items": {
      get: {
        tags: ["ข้อมูลแผนที่ฐาน"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "เส้นขอบเขตสถานที่สำคัญ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.object_id:1",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box]( http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              id_code: {
                                type: "integer",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              name_code_e: {
                                type: "string",
                              },
                              name_code_t: {
                                type: "string",
                              },
                              name_e: {
                                type: "string",
                              },
                              name_t: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [
                            [100.64222148, 14.02780136],
                            [100.64232587, 14.02775257],
                          ],
                        },
                        properties: {
                          _id: "5e9a7389bf0ce74686092001",
                          creation_user: "",
                          date_created: null,
                          date_modified: null,
                          design_id: "",
                          geohash: "w4rxf1tmve",
                          label_text: " ",
                          last_user: "",
                          lb_status: "P",
                          name: "1",
                          object_id: 1,
                          sub_type_code: 1001,
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/center-lines/items": {
      get: {
        tags: ["ข้อมูลแผนที่ฐาน"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "เส้นกึ่งกลางถนน",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description:
              "หากท่านยังไม่มี API Key  [สมัครใช้งานบริการ]( http://172.30.10.13:30100/user/register)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ  รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.name:~ซอยประชาร่วมใจ",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ  [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              brd_nam_e: {
                                type: "string",
                              },
                              brd_nam_t: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              lb_status: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nick_name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              rdln_lane: {
                                type: "integer",
                              },
                              rdln_name: {
                                type: "string",
                              },
                              rdln_num: {
                                type: "string",
                              },
                              rdln_width: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.77729319,
                              13.84482082
                            ],
                            [
                              100.77907192,
                              13.84162601
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "6086ea51c9d11e813021d262",
                          "brd_nam_e": "",
                          "brd_nam_t": "",
                          "center_line_name": "ซอยประชาร่วมใจ 45",
                          "creation_user": " ",
                          "date_created": null,
                          "date_modified": "2012-02-28T17:00:00Z",
                          "design_id": " ",
                          "geohash": "w4rwv0rgcj",
                          "global_id": "{4AD2D712-F164-491E-BD59-236AD53FB5CB}",
                          "last_user": "mea2071710",
                          "lb_status": "P",
                          "name": "ซอยประชาร่วมใจ 45",
                          "nick_name": "",
                          "object_id": 3,
                          "rdln_lane": null,
                          "rdln_name": "",
                          "rdln_num": "",
                          "rdln_width": null,
                          "sub_type_code": 5002,
                          "tag": "330000000615925",
                          "work_flow_status": 0,
                          "work_function": 0,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }
                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/road-edges/items": {
      get: {
        tags: ["ข้อมูลแผนที่ฐาน"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "เส้นขอบเขตถนน",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.lb_status:P",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              lb_status: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nick_name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [
                            [100.77433198, 13.68729572],
                            [100.77430971, 13.6871019],
                            [100.7742974, 13.68693301],
                            [100.77428411, 13.68663118],
                            [100.77429789, 13.68618224],
                          ],
                        },
                        properties: {
                          _id: "5ea2994e8f5688872fda1001",
                          creation_user: "mea2142133",
                          date_created: "2020-01-10T10:08:34Z",
                          date_modified: "2020-01-10T10:09:17Z",
                          design_id: "",
                          geohash: "w4rtv5twk0",
                          last_user: "mea2142133",
                          lb_status: "P",
                          name: "2901160",
                          object_id: 2901160,
                          sub_type_code: 3003,
                          work_flow_status: 0,
                          work_function: 0,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                      {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [
                            [100.77431421, 13.68573427],
                            [100.7743192, 13.68590591],
                            [100.77431638, 13.6861826],
                            [100.77430262, 13.68663106],
                            [100.77431587, 13.68693197],
                          ],
                        },
                        properties: {
                          _id: "5ea2994e8f5688872fda002",
                          creation_user: "mea2142133",
                          date_created: "2020-01-10T09:59:42Z",
                          date_modified: "2020-01-10T10:12:39Z",
                          design_id: "",
                          geohash: "w4rtv5mt5t",
                          last_user: "mea2142133",
                          lb_status: "P",
                          name: "2901156",
                          object_id: 2901156,
                          sub_type_code: 3003,
                          work_flow_status: 0,
                          work_function: 0,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/buildings/items": {
      get: {
        tags: ["ข้อมูลแผนที่ฐาน"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "อาคาร",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.building_name:บริษัท",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
              example: 2,
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              building_name: {
                                type: "string",
                              },
                              building_num: {
                                type: "integer",
                              },
                              building_type: {
                                type: "integer",
                              },
                              building_used: {
                                type: "integer",
                              },
                              bul_tag: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              district: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              house_id: {
                                type: "string",
                              },
                              house_no: {
                                type: "string",
                              },
                              house_org: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              lb_status: {
                                type: "string",
                              },
                              moo: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nick_name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              post_code: {
                                type: "integer",
                              },
                              province: {
                                type: "string",
                              },
                              soi: {
                                type: "string",
                              },
                              street: {
                                type: "string",
                              },
                              sub_district: {
                                type: "string",
                              },
                              tel: {
                                type: "string",
                              },
                              village_name: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "Polygon",
                          coordinates: [
                            [
                              [100.90737764, 13.56540557],
                              [100.90734305, 13.5653541],
                              [100.9072951, 13.56538494],
                              [100.90722638, 13.56528272],
                              [100.90745603, 13.56513494],
                              [100.90746948, 13.56515493],
                              [100.90769087, 13.56501247],
                              [100.90769901, 13.56502458],
                              [100.9083715, 13.56459185],
                            ],
                          ],
                        },
                        properties: {
                          _id: "5ea3acc92393c81091a15001",
                          building_name: "บริษัท",
                          building_num: null,
                          building_type: null,
                          building_used: null,
                          bul_tag: "4193436",
                          creation_user: "os6660021",
                          date_created: "1465-03-13T17:00:00Z",
                          date_modified: "1465-07-14T17:00:00Z",
                          design_id: " ",
                          district: "",
                          geohash: "w4rv0jw80q",
                          house_id: " ",
                          house_no: " ",
                          house_org: "",
                          label_text: " ",
                          last_user: "os8880020",
                          lb_status: "P",
                          moo: "",
                          name: "บริษัท",
                          object_id: 3178632,
                          post_code: "",
                          province: "",
                          soi: "",
                          street: "",
                          sub_district: "",
                          tel: " ",
                          village_name: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                      {
                        type: "Feature",
                        geometry: {
                          type: "Polygon",
                          coordinates: [
                            [
                              [100.56960255, 13.57215084],
                              [100.56935846, 13.57209549],
                              [100.5693615, 13.57207906],
                              [100.56935193, 13.57207601],
                              [100.56936927, 13.57200001],
                              [100.56937655, 13.572002],
                              [100.56940533, 13.57189701],
                            ],
                          ],
                        },
                        properties: {
                          _id: "5ea3aa102393c81091a0c002",
                          building_name: "บริษัท",
                          building_num: null,
                          building_type: null,
                          building_used: null,
                          bul_tag: "4073265",
                          creation_user: "mea1656720",
                          date_created: "1465-02-15T17:00:00Z",
                          date_modified: "1472-02-19T17:00:00Z",
                          design_id: " ",
                          district: "",
                          geohash: "w4rt0w8x98",
                          house_id: " ",
                          house_no: " ",
                          house_org: "",
                          label_text: " ",
                          last_user: "esri0362",
                          lb_status: "P",
                          moo: "",
                          name: "บริษัท",
                          object_id: 3112560,
                          post_code: "",
                          province: "",
                          soi: "",
                          street: "",
                          sub_district: "",
                          tel: " ",
                          village_name: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/building-lines/items": {
      get: {
        tags: ["ข้อมูลแผนที่ฐาน"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "เส้นแบ่งอาคาร",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.lb_status:J",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              lb_status: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.5002047,
                              13.64836595
                            ],
                            [
                              100.50027905,
                              13.64851794
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "6087b20a8f1387f9e439aa0d",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": null,
                          "design_id": "",
                          "geohash": "w4rmwuw52x",
                          "global_id": "{FF50DFF0-CC66-4C39-AF75-025414CECE02}",
                          "last_user": "",
                          "lb_status": "J",
                          "name": "{FF50DFF0-CC66-4C39-AF75-025414CECE02}",
                          "object_id": 63958,
                          "sub_type_code": 4002,
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }
                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/hydrologys/items": {
      get: {
        tags: ["ข้อมูลแผนที่ฐาน"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "แม่น้ำ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description:
              "หากท่านยังไม่มี API Key  [สมัครใช้งานบริการ]( http://172.30.10.13:30100/user/register)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.name:คลอง",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              hydro_name: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              lb_status: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.43716405,
                              13.82900371
                            ],
                            [
                              100.43720433,
                              13.82892858
                            ],
                            [
                              100.43769496,
                              13.82875766
                            ],
                            [
                              100.43773574,
                              13.82874452
                            ],
                            [
                              100.43772798,
                              13.82874761
                            ],
                            [
                              100.43775803,
                              13.82883671
                            ],
                            [
                              100.43779292,
                              13.82882822
                            ],
                            [
                              100.43781397,
                              13.82882214
                            ],
                            [
                              100.43781995,
                              13.82884371
                            ],
                            [
                              100.43781752,
                              13.82884771
                            ],
                            [
                              100.43784777,
                              13.82894589
                            ],
                            [
                              100.43782674,
                              13.82895257
                            ],
                            [
                              100.43783911,
                              13.82899127
                            ],
                            [
                              100.43786356,
                              13.82906493
                            ],
                            [
                              100.43790241,
                              13.82906282
                            ],
                            [
                              100.43798389,
                              13.82904451
                            ],
                            [
                              100.43800108,
                              13.82912166
                            ],
                            [
                              100.43802867,
                              13.8291138
                            ],
                            [
                              100.43804523,
                              13.82916251
                            ],
                            [
                              100.43806011,
                              13.82918236
                            ],
                            [
                              100.43807455,
                              13.82920037
                            ],
                            [
                              100.43808681,
                              13.82924683
                            ],
                            [
                              100.43808573,
                              13.82930435
                            ],
                            [
                              100.43811997,
                              13.82931529
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "6087bf3050d871b47c644139",
                          "creation_user": "mea1540306",
                          "date_created": "2011-03-03T17:00:00Z",
                          "date_modified": "2014-05-22T17:00:00Z",
                          "design_id": "",
                          "geohash": "w4rqtt2pg9",
                          "global_id": "{FE59A5C9-127F-414A-A6D0-DA49815F969B}",
                          "hydro_name": "คลอง",
                          "last_user": "esri8452",
                          "lb_status": "P",
                          "name": "คลอง",
                          "object_id": 443452,
                          "sub_type_code": 6002,
                          "work_flow_status": 0,
                          "work_function": 0,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }
                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/low-voltage-meters/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "มิเตอร์ไฟฟ้าแรงต่ำ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.electric_trace_weight:2048",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              amps_allow: {
                                type: "integer",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              arc_tag: {
                                type: "string",
                              },
                              bul_tag: {
                                type: "string",
                              },
                              cctv_load: {
                                type: "string",
                              },
                              code_zone: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              creationxfr_tag_user: {
                                type: "string",
                              },
                              cust_type: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              meter_no: {
                                type: "string",
                              },
                              meter_no10: {
                                type: "string",
                              },
                              meter_section: {
                                type: "string",
                              },
                              meter_type: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              old_meter_no: {
                                type: "string",
                              },
                              old_meter_section: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              related_master_gmeter_oid: {
                                type: "integer",
                              },
                              related_xfr_oid: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.62263725,
                            13.76242223
                          ]
                        },
                        "properties": {
                          "_id": "60880f33e80d53de3cc403c2",
                          "amps_allow": 5,
                          "ancillary_role": null,
                          "arc_tag": "",
                          "bul_tag": "",
                          "cctv_load": "5.07",
                          "code_zone": "",
                          "creation_user": "mea2224320",
                          "creationxfr_tag_user": "",
                          "cust_type": "CTV",
                          "date_created": "2017-10-01T08:22:14Z",
                          "date_modified": null,
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 2048,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder_id": "RH412",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rw39r5vm",
                          "global_id": "{0E5AA346-D5CA-4608-B108-75E370835DAA}",
                          "label_text": "",
                          "last_user": "",
                          "mea_district_code_e": "LPD.",
                          "mea_district_code_t": "ฟขร.",
                          "mea_district_id": 55,
                          "mea_district_name_e": "Nuan Chan District",
                          "mea_district_name_t": "การไฟฟ้าเขตนวลจันทร์",
                          "meter_no": "",
                          "meter_no10": "0",
                          "meter_section": "068",
                          "meter_type": "R",
                          "name": "{0E5AA346-D5CA-4608-B108-75E370835DAA}",
                          "object_id": 4223542,
                          "old_meter_no": "",
                          "old_meter_section": "",
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "phase_designation": 7,
                          "phases": "",
                          "related_master_gmeter_oid": null,
                          "related_xfr_oid": null,
                          "sub_type_code": 601,
                          "symbol_rotation": 92.48955293,
                          "tag": "ET0252904223542",
                          "volt_class": "L",
                          "wms_code": "",
                          "wo_id": "",
                          "work_flow_status": 0,
                          "work_function": 0,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/high-tension-meters/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "มิเตอร์ไฟฟ้าแรงสูง",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value} ตัวอย่าง properties.op_volt:M2 หมายถึง กรองข้อมูลจาก object ที่ชื่อ properties โดย op_volt มีค่าเท่ากับ M2\n",
            schema: {
              type: "string",
              example: "properties.op_volt:M2",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ โดยกำหนดคู่พิกัดในรูปแบบดังนี้ [ละติจูดต่ำสุด, ลองจิจูดต่ำสุด, ละติจูดสูงสุด, ลองจิจูดสูงสุด] ตัวอย่าง กรุงเทพมหานคร  bbox = 100.408173,13.645987,100.661545,13.840080 [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              arc_tag: {
                                type: "string",
                              },
                              bul_tag: {
                                type: "string",
                              },
                              code_zone: {
                                type: "string",
                              },
                              connect_kva: {
                                type: "integer",
                              },
                              creation_user: {
                                type: "string",
                              },
                              creationxfr_tag_user: {
                                type: "string",
                              },
                              cust_type: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              meter_no: {
                                type: "string",
                              },
                              meter_no10: {
                                type: "string",
                              },
                              meter_section: {
                                type: "string",
                              },
                              meter_type: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              old_meter_no: {
                                type: "string",
                              },
                              old_meter_section: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              related_master_gmeter_oid: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.51377726,
                            13.73242469
                          ]
                        },
                        "properties": {
                          "_id": "6087d675dd7de5ec4a781ef2",
                          "ancillary_role": 0,
                          "arc_tag": " ",
                          "bul_tag": "",
                          "code_zone": "M",
                          "connect_kva": 2500,
                          "creation_user": "",
                          "creationxfr_tag_user": " ",
                          "cust_type": "X",
                          "date_created": null,
                          "date_modified": "2016-09-20T02:31:11Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 0,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder": "SD13",
                          "feeder_id": "SD11",
                          "feeder_id2": "SD12",
                          "feeder_info": 12423,
                          "geohash": "w4rqp5zvhv",
                          "global_id": "{28D540F7-D550-4DFB-8DAC-4277D123CB10}",
                          "label_text": "M-7418",
                          "last_user": "osxsu019",
                          "mea_district_code_e": "WLD.",
                          "mea_district_code_t": "ฟขล.",
                          "mea_district_id": 66,
                          "mea_district_name_e": "Wat Liab District",
                          "mea_district_name_t": "การไฟฟ้าเขตวัดเลียบ",
                          "meter_no": "007418",
                          "meter_no10": "0011007418",
                          "meter_section": "011",
                          "meter_type": "X",
                          "name": "{28D540F7-D550-4DFB-8DAC-4277D123CB10}",
                          "object_id": 11605,
                          "old_meter_no": "007418",
                          "old_meter_section": "011",
                          "op_volt": "M2",
                          "op_volt_int": 12000,
                          "phase_designation": 7,
                          "related_master_gmeter_oid": null,
                          "sub_type_code": 132,
                          "symbol_rotation": 90,
                          "tag": "030000000142606",
                          "volt_class": "M",
                          "wms_code": "",
                          "wo_id": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }
                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/group-meters/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "มิเตอร์กลุ่ม",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.master:Y",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              arc_tag: {
                                type: "string",
                              },
                              bul_tag: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              creationxfr_tag_user: {
                                type: "string",
                              },
                              cust_type: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              location: {
                                type: "string",
                              },
                              map_sheet: {
                                type: "string",
                              },
                              meter_no: {
                                type: "string",
                              },
                              meter_section: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              num_meter: {
                                type: "integer",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              related_master_gmeter_oid: {
                                type: "integer",
                              },
                              related_dsmeter_tmp_oid: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.53243703,
                            13.82770741
                          ]
                        },
                        "properties": {
                          "_id": "6087d42084b8982bc06e479b",
                          "ancillary_role": null,
                          "arc_tag": "",
                          "bul_tag": "354908",
                          "creation_user": "mea2077329",
                          "creationxfr_tag_user": "",
                          "cust_type": "",
                          "date_created": "2009-03-23T17:00:00Z",
                          "date_modified": "2017-01-29T06:13:43Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 0,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder_id": "BZ411",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rqxtm2px",
                          "global_id": "{4F7731F3-A683-4F69-A04F-15AE3A2989B8}",
                          "label_text": "ข-007481\n( 2 METERS )",
                          "last_user": "mea2071322",
                          "location": "",
                          "map_sheet": "3538-4",
                          "master": "Y",
                          "master_no": "0094007481",
                          "mea_district_code_e": "BYD.",
                          "mea_district_code_t": "ฟขญ.",
                          "mea_district_id": 59,
                          "mea_district_name_e": "Bang Yai District",
                          "mea_district_name_t": "การไฟฟ้าเขตบางใหญ่",
                          "meter_section": "094",
                          "name": "{4F7731F3-A683-4F69-A04F-15AE3A2989B8}",
                          "num_meter": 2,
                          "object_id": 29446,
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "phase_designation": 7,
                          "related_conductor_oid": null,
                          "related_dsmeter_tmp_oid": null,
                          "sub_type_code": 131,
                          "symbol_rotation": 297.25532837,
                          "tag": "ET0000600029446",
                          "volt_class": "L",
                          "wms_code": "",
                          "wo_id": "",
                          "work_flow_status": 0,
                          "work_function": 0,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/transformers/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Transformer",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.install_type:O",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 1,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              actkva_a: {
                                type: "integer",
                                format: "double",
                              },
                              actkva_b: {
                                type: "integer",
                                format: "double",
                              },
                              actkva_c: {
                                type: "integer",
                                format: "double",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              circuit_source_id: {
                                type: "string",
                              },
                              curve_classes: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_inst1: {
                                type: "string",
                                format: "date-time",
                              },
                              date_inst2: {
                                type: "string",
                                format: "date-time",
                              },
                              date_inst3: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              district_id: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              dual: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              ground_reactance: {
                                type: "integer",
                              },
                              hi_con: {
                                type: "string",
                              },
                              hi_volt: {
                                type: "integer",
                              },
                              imped: {
                                type: "integer",
                                format: "double",
                              },
                              indx_code: {
                                type: "string",
                              },
                              install_type: {
                                type: "string",
                              },
                              int_ground_resistance: {
                                type: "integer",
                              },
                              kva_xfr1: {
                                type: "string",
                              },
                              kva_xfr2: {
                                type: "string",
                              },
                              kva_xfr3: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              lo_con: {
                                type: "integer",
                              },
                              lo_volt: {
                                type: "string",
                              },
                              low_cap: {
                                type: "string",
                              },
                              manf1: {
                                type: "string",
                              },
                              manf2: {
                                type: "string",
                              },
                              manf3: {
                                type: "string",
                              },
                              meano1: {
                                type: "string",
                              },
                              meano2: {
                                type: "string",
                              },
                              meano3: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              no_phase: {
                                type: "integer",
                              },
                              no_xfr: {
                                type: "integer",
                              },
                              nom_kva: {
                                type: "integer",
                                format: "double",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              notification: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              percent_imped: {
                                type: "integer",
                                format: "double",
                              },
                              pf: {
                                type: "integer",
                                format: "double",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              point_type: {
                                type: "string",
                              },
                              sn_status: {
                                type: "string",
                              },
                              sub_source: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "string",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              total_load: {
                                type: "integer",
                                format: "double",
                              },
                              uf: {
                                type: "integer",
                                format: "double",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                              xfr_id: {
                                type: "string",
                              },
                              xfr_type: {
                                type: "string",
                              },
                              xkva_a: {
                                type: "integer",
                                format: "double",
                              },
                              xkva_b: {
                                type: "integer",
                                format: "double",
                              },
                              xkva_c: {
                                type: "integer",
                                format: "double",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.48379435,
                            13.75758819
                          ]
                        },
                        "properties": {
                          "_id": "6087d931163bd8ff95fd5375",
                          "actkva_a": 0,
                          "actkva_b": 0,
                          "actkva_c": 0,
                          "ancillary_role": 0,
                          "circuit_source_id": 8460,
                          "creation_user": "",
                          "curve_classes": "",
                          "date_created": null,
                          "date_inst1": null,
                          "date_inst2": null,
                          "date_inst3": null,
                          "date_modified": null,
                          "design_id": "",
                          "design_text": "",
                          "district_id": "",
                          "drawing_no": "",
                          "dual": "Z",
                          "electric_trace_weight": 81920,
                          "enabled": 1,
                          "estimate_id": "",
                          "facility_id": "",
                          "feeder_id": "",
                          "feeder_id2": "",
                          "feeder_info": 8,
                          "geohash": "w4rqq86pf0",
                          "global_id": "{B2F06C49-06B3-4FBB-A90F-23764759FBC9}",
                          "ground_reactance": null,
                          "hi_con": "D",
                          "hi_volt": 12000,
                          "imped": null,
                          "indx_code": "XFOMA",
                          "install_type": "O",
                          "int_ground_resistance": null,
                          "kva_xfr1": "50",
                          "kva_xfr2": "50",
                          "kva_xfr3": "50",
                          "label_text": "3x50Y\\PO11-019",
                          "last_user": "mea",
                          "lo_con": "Y",
                          "lo_volt": 380,
                          "low_cap": "N",
                          "manf1": "Z",
                          "manf2": "Z",
                          "manf3": "Z",
                          "mea_district_code_e": "TBD.",
                          "mea_district_code_t": "ฟขธ.",
                          "mea_district_id": 58,
                          "mea_district_name_e": "Thon Buri District",
                          "mea_district_name_t": "การไฟฟ้าเขตธนบุรี",
                          "meano1": "D-2649",
                          "meano2": "D-2597",
                          "meano3": "D-2743",
                          "name": "{B2F06C49-06B3-4FBB-A90F-23764759FBC9}",
                          "no_phase": 3,
                          "no_xfr": 3,
                          "nom_kva": 150,
                          "nom_volt": "",
                          "notification": "",
                          "object_id": 2830,
                          "ohug": "O",
                          "op_volt": "M2",
                          "op_volt_int": 12000,
                          "owner": "C",
                          "percent_imped": null,
                          "pf": 0,
                          "phase_designation": 7,
                          "phases": "111",
                          "point_type": "XF",
                          "sn_status": "Z",
                          "sub_source": 1,
                          "sub_type_code": 111,
                          "symbol_rotation": 445,
                          "tag": "30312PKFT000726",
                          "total_load": 0,
                          "uf": 0,
                          "volt_class": "M",
                          "wms_code": "",
                          "wo_id": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": "",
                          "xfr_id": "PO11-019",
                          "xfr_type": "Z",
                          "xkva_a": 50,
                          "xkva_b": 50,
                          "xkva_c": 50
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/switches/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สวิตซ์",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description:
              " [สมัครใช้งานบริการ]( http://172.30.10.13:30100/user/register)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.sc_status:O",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              cont_rat: {
                                type: "integer",
                                format: "double",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              direction: {
                                type: "string",
                              },
                              district_id: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              fix_id: {
                                type: "integer",
                              },
                              fuse_size: {
                                type: "integer",
                              },
                              fuse_type: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              no_switch: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              normal_position_a: {
                                type: "integer",
                              },
                              normal_position_b: {
                                type: "integer",
                              },
                              normal_position_c: {
                                type: "integer",
                              },
                              normal_status: {
                                type: "integer",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "string",
                              },
                              point_type: {
                                type: "integer",
                              },
                              present_position_a: {
                                type: "integer",
                              },
                              present_position_b: {
                                type: "integer",
                              },
                              present_position_c: {
                                type: "integer",
                              },
                              sc_status: {
                                type: "string",
                              },
                              sn_status: {
                                type: "integer",
                              },
                              status_from_node: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              switch_id: {
                                type: "string",
                              },
                              symbol: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              ter_type: {
                                type: "string",
                              },
                              tie_switch_indicator: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.51061828,
                            13.7459478
                          ]
                        },
                        "properties": {
                          "_id": "6087ddd079c3371758d62a4e",
                          "ancillary_role": 0,
                          "cont_rat": 600,
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2021-01-22T02:34:47Z",
                          "design_id": "",
                          "design_text": "",
                          "direction": "X",
                          "district_id": "",
                          "drawing_no": "",
                          "electric_trace_weight": 1879052288,
                          "enabled": 0,
                          "estimate_id": "",
                          "facility_id": "",
                          "feeder_id": "SD46",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "fix_id": "",
                          "fuse_size": 0,
                          "fuse_type": "Z",
                          "geohash": "w4rqpnmegn",
                          "global_id": "{30540C6B-8D56-42C4-84DA-8D205A96CD9F}",
                          "indx_code": "SWUMUOD",
                          "label_text": " ",
                          "last_user": "mea2167228",
                          "mea_district_code_e": "WLD.",
                          "mea_district_code_t": "ฟขล.",
                          "mea_district_id": 66,
                          "mea_district_name_e": "Wat Liab District",
                          "mea_district_name_t": "การไฟฟ้าเขตวัดเลียบ",
                          "name": "{30540C6B-8D56-42C4-84DA-8D205A96CD9F}",
                          "no_switch": "3",
                          "nom_volt": "",
                          "normal_position_a": null,
                          "normal_position_b": null,
                          "normal_position_c": null,
                          "normal_status": 0,
                          "object_id": 29930,
                          "ohug": "U",
                          "op_volt": "M2",
                          "op_volt_int": 12000,
                          "phase_designation": 7,
                          "point_type": "SW",
                          "present_position_a": null,
                          "present_position_b": null,
                          "present_position_c": null,
                          "sc_status": "O",
                          "sn_status": "O",
                          "status_from_node": "O",
                          "sub_type_code": 254,
                          "switch_id": " ",
                          "symbol": 356,
                          "symbol_rotation": 427,
                          "tag": "030000000120460",
                          "ter_type": "Z",
                          "tie_switch_indicator": "",
                          "volt_class": "M",
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/fuses/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Fuse",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.fuse_size:100",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              aerial_type: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              fuse_size: {
                                type: "integer",
                              },
                              fuse_type: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              normal_position_a: {
                                type: "integer",
                              },
                              normal_position_b: {
                                type: "integer",
                              },
                              normal_position_c: {
                                type: "integer",
                              },
                              normal_status: {
                                type: "integer",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "string",
                              },
                              point_type: {
                                type: "integer",
                              },
                              present_position_a: {
                                type: "integer",
                              },
                              present_position_b: {
                                type: "integer",
                              },
                              present_position_c: {
                                type: "integer",
                              },
                              sn_status: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.53263438,
                            13.66058992
                          ]
                        },
                        "properties": {
                          "_id": "6087e122dede33a538b3f38d",
                          "aerial_type": "C",
                          "ancillary_role": null,
                          "creation_user": "mea2050923",
                          "date_created": "2009-01-15T17:00:00Z",
                          "date_modified": "2015-06-12T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "drawing_no": "",
                          "electric_trace_weight": 0,
                          "enabled": 1,
                          "estimate_id": "",
                          "facility_id": "",
                          "feeder_id": "RN16",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "fuse_size": 100,
                          "fuse_type": "T",
                          "geohash": "w4rmxwvdsn",
                          "global_id": "{99FAD861-8C84-43D2-9A37-715B927BCF32}",
                          "indx_code": "",
                          "label_text": "",
                          "last_user": "esri6991",
                          "mea_district_code_e": "RBD.",
                          "mea_district_code_t": "ฟขบ.",
                          "mea_district_id": 68,
                          "mea_district_name_e": "Rat Burana District",
                          "mea_district_name_t": "การไฟฟ้าเขตราษฎร์บูรณะ",
                          "name": "{99FAD861-8C84-43D2-9A37-715B927BCF32}",
                          "nom_volt": "",
                          "normal_position_a": 1,
                          "normal_position_b": 1,
                          "normal_position_c": 1,
                          "normal_status": 1,
                          "num_fuse": 1,
                          "object_id": 49281,
                          "ohug": "O",
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "phase_designation": null,
                          "point_type": "",
                          "present_position_a": 1,
                          "present_position_b": 1,
                          "present_position_c": 1,
                          "sn_status": "C",
                          "sub_type_code": 225,
                          "symbol_rotation": 332.66661914,
                          "tag": "ET0000500049281",
                          "volt_class": "L",
                          "wms_code": "",
                          "work_flow_status": 0,
                          "work_function": 0,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/capacitors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Capacitor",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.op_volt_int:12000",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              c_control: {
                                type: "string",
                              },
                              cap_id: {
                                type: "string",
                              },
                              cap_status: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_inst: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "string",
                              },
                              enabled: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              feeder_info: {
                                type: "integer",
                                format: "double",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              meano1: {
                                type: "string",
                              },
                              meano10: {
                                type: "string",
                              },
                              meano11: {
                                type: "string",
                              },
                              meano12: {
                                type: "string",
                              },
                              meano2: {
                                type: "string",
                              },
                              meano3: {
                                type: "string",
                              },
                              meano4: {
                                type: "string",
                              },
                              meano5: {
                                type: "string",
                              },
                              meano6: {
                                type: "string",
                              },
                              meano7: {
                                type: "string",
                              },
                              meano8: {
                                type: "string",
                              },
                              meano9: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              no_phase: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              num_cap: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              sn_status: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              total_kvar: {
                                type: "integer",
                                format: "double",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.51578137,
                            13.72883019
                          ]
                        },
                        "properties": {
                          "_id": "6087e2e64c3500abc6acdb8a",
                          "ancillary_role": 0,
                          "c_control": "Z",
                          "cap_id": "SY11-002",
                          "cap_status": "E",
                          "creation_user": "",
                          "date_created": null,
                          "date_inst": null,
                          "date_modified": "2020-11-17T07:09:30Z",
                          "design_id": "",
                          "design_text": "",
                          "district_id": "",
                          "drawing_no": "",
                          "electric_trace_weight": 0,
                          "enabled": 1,
                          "estimate_id": "",
                          "facility_id": "",
                          "feeder_id": "SY21",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "fulk_lk_size": 0,
                          "geohash": "w4rqp7325r",
                          "global_id": "{C970932B-BF9D-465C-822F-7918DEDB2315}",
                          "indx_code": "CPOMF",
                          "kvar": 200,
                          "label_text": "3x200KVAR\\SY11-002",
                          "last_user": "mea2142133",
                          "mea_district_code_e": "KTD.",
                          "mea_district_code_t": "ฟขต.",
                          "mea_district_id": 67,
                          "mea_district_name_e": "Klong Toei District",
                          "mea_district_name_t": "การไฟฟ้าเขตคลองเตย",
                          "meano1": "FC-100",
                          "meano10": " ",
                          "meano11": " ",
                          "meano12": " ",
                          "meano2": "FC-100",
                          "meano3": "FC-100",
                          "meano4": " ",
                          "meano5": " ",
                          "meano6": " ",
                          "meano7": " ",
                          "meano8": " ",
                          "meano9": " ",
                          "name": "{C970932B-BF9D-465C-822F-7918DEDB2315}",
                          "no_phase": 1,
                          "nom_volt": "",
                          "num_cap": 3,
                          "object_id": 1571,
                          "ohug": "O",
                          "op_volt": "M2",
                          "op_volt_int": 12000,
                          "phase_designation": 7,
                          "point_type": "CP",
                          "sn_status": "C",
                          "sub_type_code": 114,
                          "symbol_rotation": 187,
                          "tag": "34273PKF0000483",
                          "total_kvar": null,
                          "volt_class": "M",
                          "voltage": 12000,
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                                      
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/lightning-arrestors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Lightning Arrestor",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description:
              " [สมัครใช้งานบริการ]( http://172.30.10.13:30100/user/register)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.indx_code:LAOM",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              comments: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_inst: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              sn_status: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.59338823,
                            13.83588022
                          ]
                        },
                        "properties": {
                          "_id": "6087e3f417b3943a97b4d3e6",
                          "comments": "",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2014-10-01T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "drawing_no": "",
                          "estimate_id": "",
                          "geohash": "w4rw9n9zgg",
                          "global_id": "{3DA18D95-5070-4603-B2E5-BB0043759D32}",
                          "indx_code": "LAOM",
                          "label_text": " ",
                          "last_user": "esri3173",
                          "mea_district_code_e": "LPD.",
                          "mea_district_code_t": "ฟขร.",
                          "mea_district_id": 55,
                          "mea_district_name_e": "Nuan Chan District",
                          "mea_district_name_t": "การไฟฟ้าเขตนวลจันทร์",
                          "name": "{3DA18D95-5070-4603-B2E5-BB0043759D32}",
                          "nom_volt": "",
                          "object_id": 7379,
                          "ohug": "O",
                          "op_volt": "M",
                          "op_volt_int": null,
                          "point_type": "LA",
                          "sn_status": "Z",
                          "sub_type_code": 123,
                          "symbol_rotation": 513,
                          "tag": "050000000054173",
                          "volt_class": "M",
                          "wms_code": "",
                          "wo_id": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/inline-equipments/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "อุปกรณ์ประกอบสาย",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.indx_code:INOLC",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "string",
                              },
                              enabled: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              sn_status: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.6001946,
                            13.72597833
                          ]
                        },
                        "properties": {
                          "_id": "6087e895c3ac53a4fbfc1074",
                          "ancillary_role": 0,
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2016-07-30T02:12:55Z",
                          "design_id": "",
                          "design_text": "",
                          "drawing_no": "",
                          "electric_trace_weight": 0,
                          "enabled": 1,
                          "estimate_id": "",
                          "facility_id": "",
                          "feeder_id": "BA432",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rw14wzd7",
                          "global_id": "{DA52D295-BEEB-4ED8-89A3-9A93132EC8BA}",
                          "indx_code": "INOLC",
                          "label_text": " ",
                          "last_user": "",
                          "mea_district_code_e": "BKD.",
                          "mea_district_code_t": "ฟขก.",
                          "mea_district_id": 76,
                          "mea_district_name_e": "Bang Kapi District",
                          "mea_district_name_t": "การไฟฟ้าเขตบางกะปิ",
                          "name": "{DA52D295-BEEB-4ED8-89A3-9A93132EC8BA}",
                          "nom_volt": "",
                          "object_id": 589909,
                          "ohug": "O",
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "phase_designation": 7,
                          "point_type": "IN",
                          "sn_status": "Z",
                          "sub_type_code": 270,
                          "symbol_rotation": 268,
                          "tag": "43273PKIP002506",
                          "volt_class": "L",
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/grounds/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Ground",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.op_volt:L1",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              comments: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              sn_status: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.58835675,
                            13.72795539
                          ]
                        },
                        "properties": {
                          "_id": "6088c65182700ae22d6f2f0a",
                          "comments": "",
                          "creation_user": "mea2287009",
                          "date_created": "2015-01-21T17:00:00Z",
                          "date_modified": "2015-05-06T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "drawing_no": "",
                          "estimate_id": "",
                          "geohash": "w4rw0gn5ns",
                          "global_id": "{99404D6C-94B7-48A9-AAE3-E7E209301D33}",
                          "indx_code": "",
                          "label_text": "",
                          "last_user": "ortho04",
                          "mea_district_code_e": "BKD.",
                          "mea_district_code_t": "ฟขก.",
                          "mea_district_id": 76,
                          "mea_district_name_e": "Bang Kapi District",
                          "mea_district_name_t": "การไฟฟ้าเขตบางกะปิ",
                          "name": "{99404D6C-94B7-48A9-AAE3-E7E209301D33}",
                          "nom_volt": "",
                          "object_id": 357170,
                          "ohug": "O",
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "point_type": "",
                          "sn_status": "C",
                          "sub_type_code": 120,
                          "symbol_rotation": 126.47380003,
                          "tag": "ET0005000357170",
                          "volt_class": "L",
                          "wms_code": "",
                          "wo_id": "",
                          "work_flow_status": 0,
                          "work_function": 0,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/span-guys/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Guy",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.tag:~AKFM",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              comments: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              sn_status: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.89411901,
                              13.93592778
                            ],
                            [
                              100.89415011,
                              13.93617814
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "6088c90e3761a8bc8af61d5c",
                          "comments": "",
                          "const_type": " ",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2014-08-26T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "drawing_no": "",
                          "estimate_id": "",
                          "geohash": "w4rxrbuyem",
                          "global_id": "{915EC9EC-53C8-4A1E-BDBE-4C632B133B55}",
                          "label_text": " ",
                          "last_user": "ortho14",
                          "matl": " ",
                          "name": "{915EC9EC-53C8-4A1E-BDBE-4C632B133B55}",
                          "object_id": 1,
                          "op_volt": "Z",
                          "op_volt_int": null,
                          "sub_type_code": 44,
                          "symbol_rotation": null,
                          "tag": "74512AKFM000027",
                          "volt_class": "X",
                          "wires": 0,
                          "wms_code": "",
                          "wo_id": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/poles/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "เสาไฟฟ้า",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.op_volt:Z",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              grd_wire: {
                                type: "string",
                              },
                              image_path: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              notification: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              pole_height: {
                                type: "integer",
                                format: "double",
                              },
                              pole_no: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                              xarm_type1: {
                                type: "string",
                              },
                              xarm_type2: {
                                type: "string",
                              },
                              xarm_type3: {
                                type: "string",
                              },
                              xarm_type4: {
                                type: "string",
                              },
                              year_inst: {
                                type: "integer",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.65328778,
                            13.68084179
                          ]
                        },
                        "properties": {
                          "_id": "60895e610e0cf840a1295e33",
                          "comments": "",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": null,
                          "design_id": "",
                          "design_text": "",
                          "drawing_no": "",
                          "estimate_id": "",
                          "geohash": "w4rtf6t2xt",
                          "global_id": "{05DA94C5-EC1E-483D-9F28-BB856AF2161C}",
                          "grd_wire": "N",
                          "image_path": "",
                          "label_text": "12-10",
                          "last_user": " ",
                          "mea_district_code_e": "PWD.",
                          "mea_district_code_t": "ฟขศ.",
                          "mea_district_id": 65,
                          "mea_district_name_e": "Bang Na District",
                          "mea_district_name_t": "การไฟฟ้าเขตบางนา",
                          "name": "{05DA94C5-EC1E-483D-9F28-BB856AF2161C}",
                          "notification": "",
                          "object_id": 675702,
                          "op_volt": "Z",
                          "op_volt_int": null,
                          "owner": "",
                          "pole_height": 12,
                          "pole_no": "10",
                          "req_no": "",
                          "sub_type_code": 137,
                          "symbol_rotation": 134,
                          "tag": "49223PKFL001058",
                          "volt_class": "M",
                          "wms_code": "",
                          "wo_id": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": "",
                          "xarm_type1": "CSA",
                          "xarm_type2": "ZZZ",
                          "xarm_type3": "ZZZ",
                          "xarm_type4": "ZZZ",
                          "year_inst": 0
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/meter-lines/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Meter line",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.op_volt:L1",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              design_id: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.54314375,
                              13.76649298
                            ],
                            [
                              100.54305895,
                              13.76649776
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "608a760b2d43fe4d637191dc",
                          "design_id": "",
                          "electric_trace_weight": 1879048512,
                          "enabled": 1,
                          "feeder_id": "MC426",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rqrfj79h",
                          "global_id": "{2880CA7B-C2FD-4BF4-9237-E3F0F87DB854}",
                          "name": "{2880CA7B-C2FD-4BF4-9237-E3F0F87DB854}",
                          "object_id": 899184,
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "phase_designation": 7,
                          "sub_type_code": 26,
                          "volt_class": "L",
                          "wms_code": "",
                          "work_flow_status": 0,
                          "work_function": 0,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/meter-links/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Meter link",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.op_volt_int:400",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              design_id: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              obj: {
                                type: "integer",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.52505095,
                              13.71009103
                            ],
                            [
                              100.52504969,
                              13.71007662
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "608a8fd5c21dadf7ec139b1a",
                          "design_id": "",
                          "electric_trace_weight": 1879048512,
                          "enabled": 1,
                          "feeder_id": "MM415",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rmzxb556",
                          "global_id": "{FE42D71A-4ACB-479F-8E0B-35DCFFB5CF20}",
                          "name": "{FE42D71A-4ACB-479F-8E0B-35DCFFB5CF20}",
                          "obj": null,
                          "object_id": 1538669,
                          "op_volt": "",
                          "op_volt_int": 400,
                          "phase_designation": 7,
                          "sub_type_code": 24,
                          "volt_class": "",
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/manholes/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Manhole",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.comment_:~พระราม 9",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ  [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              cbl_dwg_no: {
                                type: "string",
                              },
                              comment_: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              dev_dwg_no: {
                                type: "string",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_diagram: {
                                type: "integer",
                              },
                              facility_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              image_path: {
                                type: "string",
                              },
                              installation_date: {
                                type: "string",
                                format: "date-time",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              man_hole_id: {
                                type: "string",
                              },
                              man_hole_size: {
                                type: "string",
                              },
                              man_hole_type: {
                                type: "string",
                              },
                              manufacturer: {
                                type: "string",
                              },
                              material: {
                                type: "string",
                              },
                              model: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              position_source: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              uses: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "Point",
                          coordinates: [100.64251655, 13.74606271],
                        },
                        properties: {
                          _id: "5ea8ec7479c40b2800c30001",
                          ancillary_role: null,
                          cbl_dwg_no: " ",
                          comment_:
                            "โรงพยาบาลสมิติเวช_พระราม 9 ซอย 59 (ซอยอิสระชัย)",
                          creation_user: "",
                          date_created: null,
                          date_modified: "2012-12-04T17:00:00Z",
                          design_id: "",
                          design_text: "",
                          dev_dwg_no: " ",
                          enabled: 1,
                          estimate_id: "",
                          facility_diagram: null,
                          facility_id: "",
                          geohash: "w4rw4nmsse",
                          image_path: "",
                          installation_date: null,
                          label_text: "MH.2\\TYPE.",
                          last_user: "osxsu013",
                          man_hole_id: "MH.2",
                          man_hole_size: "",
                          man_hole_type: "Z",
                          manufacturer: "",
                          material: "",
                          model: "",
                          name: "629",
                          object_id: 629,
                          position_source: 4,
                          sub_type_code: 501,
                          symbol_rotation: 424,
                          tag: "ET0003400000629",
                          uses: "Z",
                          wms_code: "",
                          wo_id: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                      {
                        type: "Feature",
                        geometry: {
                          type: "Point",
                          coordinates: [100.64178736, 13.74640898],
                        },
                        properties: {
                          _id: "5ea8ec7479c40b2800c30002",
                          ancillary_role: null,
                          cbl_dwg_no: " ",
                          comment_:
                            "โรงพยาบาลสมิติเวช_พระราม 9 ซอย 59 (ซอยอิสระชัย)",
                          creation_user: "",
                          date_created: null,
                          date_modified: "2012-12-04T17:00:00Z",
                          design_id: "",
                          design_text: "",
                          dev_dwg_no: " ",
                          enabled: 1,
                          estimate_id: "",
                          facility_diagram: null,
                          facility_id: "",
                          geohash: "w4rw4nmnes",
                          image_path: "",
                          installation_date: null,
                          label_text: "MH.3\\TYPE.",
                          last_user: "osxsu013",
                          man_hole_id: "MH.3",
                          man_hole_size: "",
                          man_hole_type: "Z",
                          manufacturer: "",
                          material: "",
                          model: "",
                          name: "630",
                          object_id: 630,
                          position_source: 4,
                          sub_type_code: 501,
                          symbol_rotation: 424,
                          tag: "ET0003400000630",
                          uses: "Z",
                          wms_code: "",
                          wo_id: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/splices/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Splice",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.sp_size:Z",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              dev_dwg_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "integer",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              sn_status: {
                                type: "string",
                              },
                              sp_size: {
                                type: "string",
                              },
                              sp_type: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.48559922,
                            13.75689881
                          ]
                        },
                        "properties": {
                          "_id": "6088d1605089b45ff0217321",
                          "ancillary_role": 0,
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2010-03-08T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "drawing_no": "",
                          "electric_trace_weight": 0,
                          "enabled": 1,
                          "estimate_id": "",
                          "facility_id": "",
                          "feeder_id": "",
                          "feeder_id2": "",
                          "feeder_info": 8,
                          "geohash": "w4rqq877sp",
                          "global_id": "{CBC8BD1F-C9C6-41A4-9314-3BE8DB8ECCE0}",
                          "indx_code": "INUXN",
                          "label_text": " ",
                          "last_user": "esri_mee",
                          "mea_district_code_e": "TBD.",
                          "mea_district_code_t": "ฟขธ.",
                          "mea_district_id": 58,
                          "mea_district_name_e": "Thon Buri District",
                          "mea_district_name_t": "การไฟฟ้าเขตธนบุรี",
                          "name": "{CBC8BD1F-C9C6-41A4-9314-3BE8DB8ECCE0}",
                          "nom_volt": "",
                          "object_id": 7006,
                          "ohug": "U",
                          "op_volt": "Z",
                          "op_volt_int": 24000,
                          "phase_designation": 7,
                          "point_type": "IN",
                          "sn_status": "C",
                          "sp_con": "Z",
                          "sp_size": "Z",
                          "sp_type": "Z",
                          "sub_type_code": 275,
                          "symbol_rotation": 93,
                          "tag": "30312PKIT002042",
                          "volt_class": "Z",
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/cctvs/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "CCTV",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.detail:~/55",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              amp_size: {
                                type: "integer",
                                format: "double",
                              },
                              cctv_count: {
                                type: "integer",
                              },
                              design_id: {
                                type: "string",
                              },
                              detail: {
                                type: "string",
                              },
                              dvr_count: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              install_date: {
                                type: "string",
                                format: "date-time",
                              },
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "Point",
                          "coordinates": [
                            100.64283622,
                            13.667639
                          ]
                        },
                        "properties": {
                          "_id": "6088d2bf0831c05a78f2c005",
                          "amp_size": 5.05,
                          "cctv_count": 4,
                          "design_id": "",
                          "detail": "65-300000456912/55",
                          "dvr_count": 1,
                          "geohash": "w4rtf0jgu0",
                          "global_id": "{74AB1698-7AE2-4F9A-85F8-856597F21171}",
                          "install_date": "2014-01-27T17:00:00Z",
                          "mea_district_code_e": "PWD.",
                          "mea_district_code_t": "ฟขศ.",
                          "mea_district_id": 65,
                          "mea_district_name_e": "Bang Na District",
                          "mea_district_name_t": "การไฟฟ้าเขตบางนา",
                          "name": "{74AB1698-7AE2-4F9A-85F8-856597F21171}",
                          "object_id": 60,
                          "owner": "สจส",
                          "symbol_rotation": null,
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/ohhv-conductors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายไฟฟ้าอากาศแรงสูง",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.ckt_size:400",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              spacing: {
                                type: "string",
                              },
                              static_feeder: {
                                type: "string",
                              },
                              static_length: {
                                type: "integer",
                                format: "double",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.57940906,
                              13.8795627
                            ],
                            [
                              100.57963582,
                              13.87998963
                            ],
                            [
                              100.57978617,
                              13.88023852
                            ],
                            [
                              100.57994384,
                              13.8805155
                            ],
                            [
                              100.58012066,
                              13.88081448
                            ],
                            [
                              100.58038242,
                              13.88127419
                            ],
                            [
                              100.58047135,
                              13.88143297
                            ],
                            [
                              100.58058973,
                              13.88164182
                            ],
                            [
                              100.58074379,
                              13.88192165
                            ],
                            [
                              100.58091731,
                              13.88224998
                            ],
                            [
                              100.58113094,
                              13.88256309
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "60891320ee321c2653df2716",
                          "a_imped": "1",
                          "arc_type": "CN",
                          "b_imped": "1",
                          "c_imped": "1",
                          "ckt_size": "400",
                          "ckt_type": "400  A",
                          "const_type": " ",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2015-11-06T04:19:34Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 1879048192,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder": "JWT7913",
                          "feeder_id": "KRT791B",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rwbwxwq4",
                          "global_id": "{E5F0D9FD-E3FF-434F-A27B-AC5D8A9862E1}",
                          "imp_type": "400  A   51H1",
                          "indx_code": "CNOH1",
                          "label_text": "6-400A",
                          "last_user": "2142133",
                          "matl": "A",
                          "name": "{E5F0D9FD-E3FF-434F-A27B-AC5D8A9862E1}",
                          "neut_matl": "Z",
                          "neut_num": 0,
                          "neut_size": "Z",
                          "neut_type": "X    X",
                          "object_id": 5821,
                          "op_volt": "H1",
                          "op_volt_int": 115000,
                          "phase_designation": 7,
                          "phases": "111",
                          "spacing": "51",
                          "static_feeder": "JWT7913",
                          "static_length": 380.75062874,
                          "sub_type_code": 1,
                          "tag": "41443AKFB000745",
                          "volt_class": "H",
                          "wires": 6,
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/ohmv-conductors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายไฟฟ้าอากาศแรงกลาง",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.arc_type:CN",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              spacing: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.48642445,
                              13.75069348
                            ],
                            [
                              100.48643031,
                              13.75069401
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "608916ad42d7f87697513baf",
                          "a_imped": "1",
                          "arc_type": "CN",
                          "b_imped": "1",
                          "c_imped": "1",
                          "ckt_size": "35",
                          "ckt_type": "35   ASC",
                          "const_type": "S",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2021-01-08T01:43:03Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 1879048672,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder": "PO13",
                          "feeder_id": "PO413",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rqnx5zx7",
                          "global_id": "{23A64E90-F8C8-481B-82D1-39E734B8A081}",
                          "imp_type": "35   ASC 15M2",
                          "indx_code": "CNOM2S",
                          "label_text": " ",
                          "last_user": "mea2278727",
                          "matl": "ASC",
                          "name": "{23A64E90-F8C8-481B-82D1-39E734B8A081}",
                          "neut_matl": "Z",
                          "neut_num": 0,
                          "neut_size": "Z",
                          "neut_type": "X    X",
                          "num_vertex": null,
                          "object_id": 269614,
                          "op_volt": "M1",
                          "op_volt_int": 24000,
                          "owner": "M",
                          "phase_designation": 7,
                          "phases": "111",
                          "spacing": "15",
                          "sub_type_code": 9,
                          "tag": "31301AKFT000077",
                          "volt_class": "M",
                          "wires": 3,
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/ohlv-conductors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายไฟฟ้าอากาศแรงต่ำ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.last_user:~mea",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              spacing: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.45344716,
                              13.77584162
                            ],
                            [
                              100.45343245,
                              13.77570019
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "608a3d3ebfb5572502eee3ea",
                          "a_imped": "",
                          "arc_type": "",
                          "b_imped": "",
                          "c_imped": "",
                          "ckt_size": "35",
                          "ckt_type": "",
                          "const_type": "",
                          "creation_user": "mea2288720",
                          "date_created": "2020-02-24T01:58:45Z",
                          "date_modified": "2020-05-28T00:51:54Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 1879048512,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder": "",
                          "feeder_id": "RC436",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rqmggfng",
                          "global_id": "{00002E50-717F-43BD-A30D-517017B3D57B}",
                          "imp_type": "",
                          "indx_code": "",
                          "label_text": "",
                          "last_user": "mea1980502",
                          "matl": "DX",
                          "name": "{00002E50-717F-43BD-A30D-517017B3D57B}",
                          "neut_matl": "DX",
                          "neut_num": 1,
                          "neut_size": "35",
                          "neut_type": "",
                          "object_id": 4168553,
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "owner": "M",
                          "phase_designation": 7,
                          "phases": "Z",
                          "spacing": "Z",
                          "sub_type_code": 18,
                          "tag": "ET0019004168553",
                          "volt_class": "L",
                          "wires": 1,
                          "wms_code": "",
                          "work_flow_status": 0,
                          "work_function": 0,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/ohlv-conductor-under-buildings/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายไฟฟ้าแรงต่ำใต้อาคาร",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.feeder_id:SD11",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              spacing: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.51291364,
                              13.74312888
                            ],
                            [
                              100.51291186,
                              13.74313654
                            ],
                            [
                              100.51289424,
                              13.74317705
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "60892703b9a687cdd0cc0e2e",
                          "a_imped": "Z",
                          "arc_type": "CN",
                          "b_imped": " ",
                          "c_imped": " ",
                          "ckt_size": "35",
                          "ckt_type": "35   AW",
                          "const_type": "B",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2014-02-23T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 1879048320,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder": " ",
                          "feeder_id": "SD11",
                          "feeder_id2": "SD12",
                          "feeder_info": 12423,
                          "geohash": "w4rqpjz788",
                          "global_id": "{CB07879B-A367-4DF8-AAC2-80DF50534838}",
                          "imp_type": "35   AW  18L1",
                          "indx_code": "CNOL1B",
                          "label_text": " ",
                          "last_user": "mea2015016",
                          "matl": "AW",
                          "name": "{CB07879B-A367-4DF8-AAC2-80DF50534838}",
                          "neut_matl": "AW",
                          "neut_num": 1,
                          "neut_size": "35",
                          "neut_type": "35   AW",
                          "object_id": 1,
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "owner": "",
                          "phase_designation": 7,
                          "phases": "Z",
                          "spacing": "18",
                          "sub_type_code": 16,
                          "tag": "33294AKF0002133",
                          "volt_class": "L",
                          "wires": 1,
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/ugmv-conductors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายไฟฟ้าใต้ดินแรงกลาง",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.tag:40513AUIN000008",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              spacing: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.57293591,
                              13.94403409
                            ],
                            [
                              100.57295131,
                              13.94403021
                            ],
                            [
                              100.57492811,
                              13.94352391
                            ],
                            [
                              100.57493972,
                              13.94352115
                            ],
                            [
                              100.57495499,
                              13.94351753
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "60892b662c31641529666d1c",
                          "a_imped": "1",
                          "arc_type": "CN",
                          "b_imped": "1",
                          "c_imped": "1",
                          "ckt_size": "400",
                          "ckt_type": "400  XLPE",
                          "const_type": "B",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2014-09-22T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 1879048192,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder": " ",
                          "feeder_id": "",
                          "feeder_id2": "",
                          "feeder_info": 0,
                          "geohash": "w4rx2d6vzk",
                          "global_id": "{BC316169-AD1E-4702-97CF-29F99E165AB2}",
                          "imp_type": "400  XLPEZ M2",
                          "indx_code": "CNUM2B",
                          "label_text": "3-400XLPE",
                          "last_user": " ",
                          "matl": "XLPE",
                          "name": "{BC316169-AD1E-4702-97CF-29F99E165AB2}",
                          "neut_matl": "Z",
                          "neut_num": 0,
                          "neut_size": "Z",
                          "neut_type": "X    X",
                          "object_id": 592,
                          "op_volt": "M2",
                          "op_volt_int": 12000,
                          "owner": "",
                          "phase_designation": 7,
                          "phases": "111",
                          "spacing": "Z",
                          "sub_type_code": 39,
                          "tag": "40513AUIN000008",
                          "volt_class": "M",
                          "wires": 3,
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/ughv-conductors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายไฟฟ้าใต้ดินแรงสูง",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              spacing: {
                                type: "string",
                              },
                              static_feeder: {
                                type: "string",
                              },
                              static_length: {
                                type: "integer",
                                format: "double",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example:{
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.58035474,
                              13.77791062
                            ],
                            [
                              100.58034946,
                              13.77791183
                            ],
                            [
                              100.58067547,
                              13.77859224
                            ],
                            [
                              100.58090967,
                              13.77908116
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "60892d9bcec7d629669827d3",
                          "a_imped": "1",
                          "arc_type": "CN",
                          "b_imped": "1",
                          "c_imped": "1",
                          "ckt_size": "800",
                          "ckt_type": "800  XLPE",
                          "const_type": "B",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2014-06-08T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 1879048192,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder": "RDT692",
                          "feeder_id": "RDT692",
                          "feeder_id2": "",
                          "feeder_info": 7,
                          "geohash": "w4rw2u0qhh",
                          "global_id": "{658AF3DA-4A11-4561-8B5D-4009A16C5D5C}",
                          "imp_type": "800  XLPEZ H2",
                          "indx_code": "CNUH2B",
                          "label_text": " ",
                          "last_user": "2142133",
                          "matl": "XLPE",
                          "name": "{658AF3DA-4A11-4561-8B5D-4009A16C5D5C}",
                          "neut_matl": "Z",
                          "neut_num": 1,
                          "neut_size": "Z",
                          "neut_type": "X    X",
                          "object_id": 1292,
                          "op_volt": "H2",
                          "op_volt_int": 69000,
                          "phase_designation": 7,
                          "phases": "111",
                          "spacing": "Z",
                          "static_feeder": "RDT692",
                          "static_length": 143.43256586,
                          "sub_type_code": 31,
                          "tag": "050000001245888",
                          "volt_class": "H",
                          "wires": 6,
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }                                    
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/uglv-conductors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายไฟฟ้าใต้ดินแรงต่ำ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.arc_type:CN",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              feeder: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              spacing: {
                                type: "string",
                              },
                              static_feeder: {
                                type: "string",
                              },
                              static_length: {
                                type: "integer",
                                format: "double",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    "type": "FeatureCollection",
                    "features": [
                      {
                        "type": "Feature",
                        "geometry": {
                          "type": "LineString",
                          "coordinates": [
                            [
                              100.49217521,
                              13.75068814
                            ],
                            [
                              100.49216347,
                              13.75064389
                            ],
                            [
                              100.49216204,
                              13.75061376
                            ],
                            [
                              100.49216912,
                              13.75058624
                            ],
                            [
                              100.49217993,
                              13.75057553
                            ],
                            [
                              100.49219533,
                              13.75057189
                            ],
                            [
                              100.49223705,
                              13.75057164
                            ],
                            [
                              100.49243877,
                              13.75056609
                            ],
                            [
                              100.49244205,
                              13.75055181
                            ],
                            [
                              100.49246414,
                              13.75020818
                            ],
                            [
                              100.49246413,
                              13.75020592
                            ],
                            [
                              100.49241463,
                              13.75023899
                            ],
                            [
                              100.49241001,
                              13.75023902
                            ],
                            [
                              100.4924048,
                              13.75023905
                            ],
                            [
                              100.49240534,
                              13.75022511
                            ],
                            [
                              100.49239609,
                              13.75022516
                            ]
                          ]
                        },
                        "properties": {
                          "_id": "60892fe9565310ed634daa9c",
                          "a_imped": "1",
                          "arc_type": "CN",
                          "b_imped": "1",
                          "c_imped": "1",
                          "ckt_size": "400",
                          "ckt_type": "400  XLPE",
                          "const_type": "B",
                          "creation_user": "",
                          "date_created": null,
                          "date_modified": "2014-05-15T17:00:00Z",
                          "design_id": "",
                          "design_text": "",
                          "electric_trace_weight": 1879048512,
                          "enabled": 1,
                          "estimate_id": "",
                          "feeder": " ",
                          "feeder_id": "WL11",
                          "feeder_id2": "WL12",
                          "feeder_info": 12423,
                          "geohash": "w4rqnz0pt6",
                          "global_id": "{C912D3BC-AFC5-431F-9D79-E2ADD8EE3856}",
                          "imp_type": "400  XLPEZ L1",
                          "indx_code": "CNUL1B",
                          "label_text": "6-400XLPE\\2-185XLPE",
                          "last_user": "esri7323",
                          "matl": "XLPE",
                          "name": "{C912D3BC-AFC5-431F-9D79-E2ADD8EE3856}",
                          "neut_matl": "XLPE",
                          "neut_num": 2,
                          "neut_size": "185",
                          "neut_type": "185  XLPE",
                          "object_id": 2283,
                          "op_volt": "L1",
                          "op_volt_int": 400,
                          "owner": "",
                          "phase_designation": 7,
                          "phases": "111",
                          "spacing": "Z",
                          "sub_type_code": 46,
                          "tag": "030000000133001",
                          "volt_class": "L",
                          "wires": 6,
                          "wms_code": "",
                          "work_flow_status": null,
                          "work_function": null,
                          "work_location_id": "",
                          "work_request_id": ""
                        }
                      }
                    ]
                  }
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/ohsl-conductors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายอากาศไฟฟ้าสาธารณะ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.neut_matl:Z",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              phases: {
                                type: "string",
                              },
                              source_id: {
                                type: "integer",
                              },
                              source_id2: {
                                type: "string",
                              },
                              source_info: {
                                type: "integer",
                              },
                              spacing: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [
                            [100.49419453, 13.84006475],
                            [100.4941967, 13.84006067],
                            [100.49422973, 13.83999867],
                            [100.49425981, 13.8399422],
                          ],
                        },
                        properties: {
                          _id: "5eabaf95a7ac6b6cf285d001",
                          a_imped: "Z",
                          arc_type: "CN",
                          b_imped: " ",
                          c_imped: " ",
                          ckt_size: "35",
                          ckt_type: "35   AW",
                          const_type: " ",
                          creation_user: "",
                          date_created: null,
                          date_modified: "2009-08-23T17:00:00Z",
                          design_id: "",
                          design_text: "",
                          electric_trace_weight: 1879048192,
                          enabled: 1,
                          estimate_id: "",
                          geohash: "w4rqwz98hr",
                          imp_type: "35   AW  18LS",
                          indx_code: "CNOLS",
                          label_text: "1-35AW(SL)",
                          last_user: " ",
                          matl: "AW",
                          name: "21316",
                          neut_matl: "Z",
                          neut_num: 0,
                          neut_size: "Z",
                          neut_type: "X    X",
                          object_id: 21316,
                          op_volt: "LS",
                          op_volt_int: 230,
                          phase_designation: 7,
                          phases: "Z",
                          source_id: "137123",
                          source_id2: "",
                          source_info: 7,
                          spacing: "18",
                          sub_type_code: 60,
                          tag: "31402AKFN000148",
                          volt_class: "L",
                          wires: 1,
                          wms_code: "",
                          wo_id: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                      {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [
                            [100.49426094, 13.8399401],
                            [100.49426984, 13.83992339],
                          ],
                        },
                        properties: {
                          _id: "5eabaf95a7ac6b6cf285d002",
                          a_imped: "Z",
                          arc_type: "CN",
                          b_imped: " ",
                          c_imped: " ",
                          ckt_size: "35",
                          ckt_type: "35   AW",
                          const_type: " ",
                          creation_user: "",
                          date_created: null,
                          date_modified: "2009-08-24T17:00:00Z",
                          design_id: "",
                          design_text: "",
                          electric_trace_weight: 1879048192,
                          enabled: 1,
                          estimate_id: "",
                          geohash: "w4rqwz3xqp",
                          imp_type: "35   AW  18LS",
                          indx_code: "CNOLS",
                          label_text: " ",
                          last_user: " ",
                          matl: "AW",
                          name: "21317",
                          neut_matl: "Z",
                          neut_num: 0,
                          neut_size: "Z",
                          neut_type: "X    X",
                          object_id: 21317,
                          op_volt: "LS",
                          op_volt_int: 230,
                          phase_designation: 7,
                          phases: "Z",
                          source_id: "137857",
                          source_id2: "",
                          source_info: 7,
                          spacing: "18",
                          sub_type_code: 60,
                          tag: "31402AKFN002298",
                          volt_class: "L",
                          wires: 1,
                          wms_code: "",
                          wo_id: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/streetlights/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "ดวงโคมไฟฟ้าสาธารณะ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.tag:23561PKFZ000160",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              bracket_len: {
                                type: "integer",
                                format: "double",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_inst: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              idol_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              lamp_id: {
                                type: "string",
                              },
                              lamp_size: {
                                type: "string",
                              },
                              lamp_size_old: {
                                type: "string",
                              },
                              lamp_size_tmp: {
                                type: "string",
                              },
                              lamp_type: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              num_lamp: {
                                type: "integer",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              pole_tag: {
                                type: "string",
                              },
                              related_pole_ID: {
                                type: "integer",
                              },
                              related_stctrlo_oid: {
                                type: "integer",
                              },
                              sn_status: {
                                type: "string",
                              },
                              source_id: {
                                type: "string",
                              },
                              source_id2: {
                                type: "string",
                              },
                              source_info: {
                                type: "integer",
                              },
                              stctrl_tag: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "Point",
                          coordinates: [100.41586861, 13.98540767],
                        },
                        properties: {
                          _id: "5eabee0aed6c6e3bcb2e1001",
                          ancillary_role: 0,
                          bracket_len: 1.8,
                          creation_user: "",
                          date_created: null,
                          date_inst: null,
                          date_modified: "2014-11-25T17:00:00Z",
                          design_id: "",
                          design_text: "",
                          drawing_no: "",
                          electric_trace_weight: 0,
                          enabled: 1,
                          estimate_id: "",
                          facility_id: "",
                          geohash: "w4rrt1bwgk",
                          idol_type: "Z",
                          indx_code: "LPOLCM",
                          label_text: "184-78",
                          lamp_id: "184",
                          lamp_size: "125",
                          lamp_size_old: "125",
                          lamp_size_tmp: "125",
                          lamp_type: "HG",
                          last_user: "os6660032",
                          name: "1",
                          nom_volt: "",
                          num_lamp: null,
                          object_id: 1,
                          ohug: "O",
                          op_volt: "Z",
                          op_volt_int: 230,
                          owner: "71",
                          phase_designation: 7,
                          point_type: "LP",
                          pole_tag: "23561PKFZ000162",
                          related_pole_ID: 115,
                          related_stctrlo_oid: 5858,
                          sn_status: "Z",
                          source_id: "552532",
                          source_id2: "",
                          source_info: 8,
                          stctrl_tag: "23562PKFZ000008",
                          sub_type_code: 279,
                          symbol_rotation: 250,
                          tag: "23561PKFZ000160",
                          volt_class: "Z",
                          wms_code: "",
                          wo_id: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/streetlight-controls/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "อุปกรณ์ควบคุมไฟฟ้าสาธารณะ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.tag:74502PKFM000022",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              comments: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              max_amp: {
                                type: "integer",
                              },
                              meter_no: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              notification: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              source_id: {
                                type: "string",
                              },
                              source_id2: {
                                type: "string",
                              },
                              source_info: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              total_amp: {
                                type: "integer",
                                format: "double",
                              },
                              voltage: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    status: {
                      code: 200,
                      message: "OK",
                    },
                    data: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "Point",
                          coordinates: [100.89285237, 13.9281906],
                        },
                        properties: {
                          _id: "5eac247dda5003a47ee40001",
                          ancillary_role: 1,
                          comments: "",
                          creation_user: "",
                          date_created: null,
                          date_modified: "2014-11-14T17:00:00Z",
                          design_id: "",
                          design_text: "",
                          district_id: "",
                          drawing_no: "",
                          electric_trace_weight: 0,
                          enabled: 1,
                          estimate_id: "",
                          facility_id: "",
                          geohash: "w4rxpzectf",
                          label_text: " ",
                          last_user: "esri7298",
                          max_amp: 0,
                          meter_no: "",
                          name: "2",
                          notification: "",
                          object_id: 2,
                          op_volt: "Z",
                          op_volt_int: 230,
                          owner: "",
                          phase_designation: 7,
                          source_id: "",
                          source_id2: "",
                          source_info: null,
                          sub_type_code: 294,
                          symbol_rotation: 352,
                          tag: "74502PKFM000022",
                          total_amp: 0,
                          voltage: "220",
                          wms_code: "",
                          wo_id: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                          xfr_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/duct-banks/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "แนวท่อร้อยสายใต้ดิน",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.tag:75181ADII000001",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box]( http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              depth: {
                                type: "string",
                              },
                              depth_left: {
                                type: "string",
                              },
                              depth_right: {
                                type: "string",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              diameter: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              duct_avail: {
                                type: "integer",
                              },
                              duct_case: {
                                type: "string",
                              },
                              duct_type: {
                                type: "string",
                              },
                              duct_used: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              end_type: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              height: {
                                type: "integer",
                                format: "double",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              length_ww: {
                                type: "integer",
                              },
                              name: {
                                type: "string",
                              },
                              no_duct: {
                                type: "integer",
                              },
                              object_id: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              uses: {
                                type: "string",
                              },
                              width: {
                                type: "integer",
                                format: "double",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [
                            [100.89538344, 13.63638107],
                            [100.89578015, 13.63717297],
                          ],
                        },
                        properties: {
                          _id: "5eb8ee2be21e54a706e97001",
                          creation_user: " ",
                          date_created: null,
                          date_modified: "2014-04-08T17:00:00Z",
                          depth: "",
                          depth_left: "",
                          depth_right: "",
                          design_id: "",
                          design_text: "ทางหลวงพิเศษหมายเลข 7 (มอเตอร์เวย์)",
                          diameter: "140",
                          drawing_no: "",
                          duct_avail: 4,
                          duct_case: "R/F",
                          duct_type: "A/C",
                          duct_used: 0,
                          enabled: 1,
                          end_type: "m.",
                          estimate_id: "",
                          geohash: "w4rtxfmv8v",
                          height: null,
                          label_text: "97 m.",
                          last_user: "esri8323",
                          length_ww: 97,
                          name: "1",
                          no_duct: 4,
                          object_id: 1,
                          owner: "",
                          sub_type_code: 405,
                          tag: "75181ADII000001",
                          uses: "Z",
                          width: null,
                          wms_code: "",
                          wo_id: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/ugsl-conductors/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายใต้ดินไฟฟ้าสาธารณะ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.spacing:Z",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              a_imped: {
                                type: "string",
                              },
                              arc_type: {
                                type: "string",
                              },
                              b_imped: {
                                type: "string",
                              },
                              c_imped: {
                                type: "string",
                              },
                              ckt_size: {
                                type: "string",
                              },
                              ckt_type: {
                                type: "string",
                              },
                              const_type: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "integer",
                              },
                              enabled: {
                                type: "integer",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              imp_type: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              matl: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              neut_matl: {
                                type: "string",
                              },
                              neut_num: {
                                type: "integer",
                              },
                              neut_size: {
                                type: "string",
                              },
                              neut_type: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              spacing: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wires: {
                                type: "integer",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "Point",
                          coordinates: [100.59400128, 13.67600558],
                        },
                        properties: {
                          _id: "5eb00bcb75ffed8ab6b65001",
                          act_voltage: 0,
                          ancillary_role: 1,
                          bay_no: 0,
                          cb_id: "MA17",
                          cb_status: "O",
                          circuit_source_id: 1050,
                          cont_rat: 0,
                          creation_user: "",
                          date_created: null,
                          date_modified: "2015-08-21T06:44:27Z",
                          design_id: "",
                          design_text: "",
                          drawing_no: "",
                          electric_trace_weight: 79616,
                          enabled: 1,
                          estimate_id: "",
                          facility_id: "",
                          feeder_id: "MA17",
                          feeder_id2: "",
                          feeder_info: 7,
                          geohash: "w4rtc1dkd0",
                          indx_code: "CBOMO",
                          int_rat: 0,
                          int_type: "VCB",
                          known_peak: 12,
                          label_text: "MA17",
                          last_user: "esri5148",
                          manf: "MD",
                          name: "6",
                          nom_volt: "",
                          nom_voltage: 12000,
                          normal_position_a: null,
                          normal_position_b: null,
                          normal_position_c: null,
                          normal_status: 1,
                          object_id: 6,
                          ohug: "O",
                          op_volt: "M2",
                          op_volt_int: 12000,
                          pf: 0,
                          phase_designation: 7,
                          point_type: "CB",
                          present_position_a: null,
                          present_position_b: null,
                          present_position_c: null,
                          radial: "1",
                          relate_sub_station_oid: null,
                          sn_status: "Z",
                          sub_source: 0,
                          sub_type_code: 0,
                          sub_xfr_id: "MA",
                          sub_xfr_oid: "42222PKIS000838",
                          symbol_rotation: 258,
                          tag: "42222PKIS000840",
                          volt_class: "M",
                          wms_code: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/fiber-optic-cables/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายสื่อสาร",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.location:~ซอยงามวงศ์วาน",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/#13.645987,100.408173,13.840080,100.661545)\n",
            schema: {
              type: "string",
              example: "100.408173,13.645987,100.661545,13.840080",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: 2,
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              abandoned_indicator: {
                                type: "integer",
                              },
                              acceptable_use: {
                                type: "string",
                              },
                              account_id: {
                                type: "string",
                              },
                              arm_type: {
                                type: "string",
                              },
                              as_built_length: {
                                type: "integer",
                              },
                              cable_diameter: {
                                type: "integer",
                              },
                              cable_length: {
                                type: "integer",
                                format: "double",
                              },
                              cable_length_in_kilometers: {
                                type: "integer",
                              },
                              cable_length_source: {
                                type: "string",
                              },
                              cable_manufacturer: {
                                type: "string",
                              },
                              cable_marking_unit_of_measure: {
                                type: "string",
                              },
                              cable_name: {
                                type: "string",
                              },
                              cable_owner: {
                                type: "string",
                              },
                              cable_twist_factor: {
                                type: "integer",
                              },
                              cable_type: {
                                type: "string",
                              },
                              cable_vendor: {
                                type: "string",
                              },
                              channel: {
                                type: "string",
                              },
                              colour_info: {
                                type: "integer",
                              },
                              comments: {
                                type: "string",
                              },
                              construction_type: {
                                type: "string",
                              },
                              contract_no: {
                                type: "string",
                              },
                              core: {
                                type: "integer",
                              },
                              creation_date: {
                                type: "string",
                                format: "date-time",
                              },
                              creation_user: {
                                type: "string",
                              },
                              cust_type: {
                                type: "string",
                              },
                              date_Commisioned: {
                                type: "string",
                                format: "date-time",
                              },
                              date_installed: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              description: {
                                type: "string",
                              },
                              design_length: {
                                type: "integer",
                              },
                              diameter: {
                                type: "integer",
                              },
                              district: {
                                type: "string",
                              },
                              document_hot_link_path: {
                                type: "string",
                              },
                              enabled: {
                                type: "integer",
                              },
                              ending_cable_length_marking: {
                                type: "integer",
                              },
                              equipment_type: {
                                type: "string",
                              },
                              est_mm_attenuation_1310: {
                                type: "integer",
                              },
                              est_mm_attenuation_850: {
                                type: "integer",
                              },
                              est_sm_attenuation_1310: {
                                type: "integer",
                                format: "dubble",
                              },
                              est_sm_attenuation_1550: {
                                type: "integer",
                                format: "double",
                              },
                              fiber_child_class_model_name: {
                                type: "string",
                              },
                              fiber_count: {
                                type: "integer",
                              },
                              fiber_parent: {
                                type: "string",
                              },
                              fiber_parent_class_model_name: {
                                type: "string",
                              },
                              fiber_type: {
                                type: "integer",
                              },
                              field_notes_length: {
                                type: "integer",
                              },
                              filling_info: {
                                type: "string",
                              },
                              frequence: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              glass_length: {
                                type: "integer",
                                format: "double",
                              },
                              global_id: {
                                type: "integer",
                              },
                              id_code: {
                                type: "integer",
                              },
                              infrastructure_class: {
                                type: "integer",
                              },
                              install_date: {
                                type: "string",
                                format: "date-time",
                              },
                              installed_by: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              leased_from: {
                                type: "string",
                              },
                              leased_from_contract_expires_on: {
                                type: "string",
                              },
                              leased_from_contract_information: {
                                type: "string",
                              },
                              leased_from_contract_number: {
                                type: "string",
                              },
                              leased_from_contract_person: {
                                type: "string",
                              },
                              leased_to: {
                                type: "string",
                              },
                              leased_to_contract_expires_on: {
                                type: "string",
                              },
                              leased_to_contract_information: {
                                type: "string",
                              },
                              leased_to_contract_number: {
                                type: "string",
                              },
                              leased_to_contract_person: {
                                type: "string",
                              },
                              location: {
                                type: "string",
                              },
                              manufacturer: {
                                type: "string",
                              },
                              mic_code: {
                                type: "string",
                              },
                              model_number: {
                                type: "string",
                              },
                              multi_mode_availability_qty: {
                                type: "integer",
                              },
                              number_of_fibers: {
                                type: "integer",
                              },
                              number_of_tubes: {
                                type: "integer",
                              },
                              object_id: {
                                type: "integer",
                              },
                              option_expires_on_date: {
                                type: "string",
                              },
                              option_to_use_indicator: {
                                type: "string",
                              },
                              overhead_underground: {
                                type: "string",
                              },
                              overlashed_indicator: {
                                type: "integer",
                              },
                              owner: {
                                type: "string",
                              },
                              percentage_of_fibers_available: {
                                type: "string",
                              },
                              phase: {
                                type: "integer",
                              },
                              product_url: {
                                type: "string",
                              },
                              project_state: {
                                type: "string",
                              },
                              project_status: {
                                type: "string",
                              },
                              proposed_fiber_optic_cable_ind: {
                                type: "integer",
                              },
                              reelid: {
                                type: "string",
                              },
                              reference: {
                                type: "string",
                              },
                              rent_exp: {
                                type: "integer",
                              },
                              rent_start: {
                                type: "integer",
                              },
                              renter: {
                                type: "string",
                              },
                              restoration_instructions: {
                                type: "string",
                              },
                              route_code: {
                                type: "string",
                              },
                              route_precision: {
                                type: "string",
                              },
                              segment_glass_length: {
                                type: "integer",
                                format: "double",
                              },
                              segment_id: {
                                type: "string",
                              },
                              segment_length: {
                                type: "integer",
                                format: "double",
                              },
                              session_status: {
                                type: "integer",
                              },
                              sheath: {
                                type: "string",
                              },
                              single_mode_availability_qty: {
                                type: "integer",
                              },
                              starting_cable_length_marking: {
                                type: "integer",
                              },
                              status: {
                                type: "string",
                              },
                              sub_type_id: {
                                type: "integer",
                              },
                              tag: {
                                type: "string",
                              },
                              this_fiber_class_model_name: {
                                type: "string",
                              },
                              tracer_wire_indicator: {
                                type: "integer",
                              },
                              wo_no: {
                                type: "string",
                              },
                              work_order_number: {
                                type: "string",
                              },
                              work_type: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [
                            [100.56898155, 13.83952751],
                            [100.5690945, 13.83935532],
                            [100.56912262, 13.83934598],
                            [100.56913795, 13.83932282],
                          ],
                        },
                        properties: {
                          _id: "5eb0499f2bb1dd227d598001",
                          abandoned_indicator: null,
                          acceptable_use: "",
                          account_id: "",
                          arm_type: 0,
                          as_built_length: 30,
                          cable_diameter: null,
                          cable_length: 28.89039676,
                          cable_length_in_kilometers: null,
                          cable_length_source: "GIS LENGTH + SLACK LOOP LENGTH",
                          cable_manufacturer: "",
                          cable_marking_unit_of_measure: "",
                          cable_name: "",
                          cable_owner: "",
                          cable_twist_factor: 1,
                          cable_type: "",
                          cable_vendor: "",
                          channel: "",
                          colour_info: null,
                          comments: "",
                          construction_type: "Loose Tube",
                          contract_no: "",
                          core: 6,
                          creation_date: "2018-05-31T03:31:54Z",
                          creation_user: "osxsu021",
                          cust_type: "",
                          date_Commisioned: null,
                          date_installed: null,
                          date_modified: "2018-05-31T03:39:52Z",
                          description: "",
                          design_length: null,
                          diameter: 11,
                          district: "ฟขข.",
                          document_hot_link_path: "",
                          enabled: 1,
                          ending_cable_length_marking: null,
                          equipment_type: "",
                          est_mm_attenuation_1310: null,
                          est_mm_attenuation_850: null,
                          est_sm_attenuation_1310: 0.001,
                          est_sm_attenuation_1550: 0.001,
                          fiber_child_class_model_name: "BUFFERTUBE",
                          fiber_count: 6,
                          fiber_parent: "",
                          fiber_parent_class_model_name: "",
                          fiber_type: 1,
                          field_notes_length: null,
                          filling_info: "",
                          frequence: "",
                          geohash: "w4rw8x2j54",
                          glass_length: 28.89039676,
                          global_id: "{73E53E0B-5BED-45C2-8801-C5CB13B84496}",
                          helicity: null,
                          id_code: null,
                          infrastructure_class: "",
                          install_date: null,
                          installed_by: "",
                          last_user: "osxsu021",
                          leased_from: "",
                          leased_from_contract_expires_on: "",
                          leased_from_contract_information: "",
                          leased_from_contract_number: "",
                          leased_from_contract_person: "",
                          leased_to: "",
                          leased_to_contract_expires_on: "",
                          leased_to_contract_information: "",
                          leased_to_contract_number: "",
                          leased_to_contract_person: "",
                          location:
                            "สถานีย่อยเกษตร (KE) C6-4 - 77114453 M1 หน้าบ้านเลขที่ 8/47 ใกล้ซอยวิภาวดีรังสิต 42 ตัด ซอยงามวงศ์วาน 54 แยก 10 ถึง ใกล้บ้านเลขที่ 23/23 ซอยงามวงศ์วาน 54 แยก 5",
                          manufacturer: "",
                          mic_code: "",
                          model_number: "6 Fiber (1x6)",
                          multi_mode_availability_qty: 0,
                          number_of_fibers: 6,
                          number_of_tubes: 1,
                          object_id: 286881,
                          option_expires_on_date: "",
                          option_to_use_indicator: "",
                          overhead_underground: "Overhead",
                          overlashed_indicator: null,
                          owner: "MEA",
                          percentage_of_fibers_available: null,
                          phase: null,
                          product_url: "",
                          project_state: "",
                          project_status: "",
                          proposed_fiber_optic_cable_ind: null,
                          reelid: "",
                          reference: "MEA_KE(AMR6) - MEA METER",
                          rent_exp: null,
                          rent_start: null,
                          renter: "",
                          restoration_instructions: "",
                          route_code: "",
                          route_precision: "",
                          segment_glass_length: 28.89039676,
                          segment_id: "",
                          segment_length: 28.89039676,
                          session_status: null,
                          sheath: "",
                          single_mode_availability_qty: 6,
                          starting_cable_length_marking: null,
                          status: "",
                          sub_type_id: 1,
                          tag: "ET0164300286881",
                          this_fiber_class_model_name: "SHEATH",
                          tracer_wire_indicator: null,
                          wo_no: "",
                          work_order_number: "",
                          work_type: "AMR",
                        },
                      },
                      {
                        type: "Feature",
                        geometry: {
                          type: "LineString",
                          coordinates: [
                            [100.56913795, 13.83932282],
                            [100.56907498, 13.83921879],
                            [100.56912789, 13.83893833],
                            [100.56919922, 13.83862442],
                            [100.56920795, 13.83859013],
                            [100.56922319, 13.83851206],
                            [100.56928831, 13.83820542],
                            [100.56935977, 13.83783108],
                            [100.56916893, 13.83778072],
                            [100.56894796, 13.83772566],
                            [100.56880512, 13.83774691],
                            [100.56880089, 13.83776141],
                          ],
                        },
                        properties: {
                          _id: "5eb0499f2bb1dd227d598002",
                          abandoned_indicator: null,
                          acceptable_use: "",
                          account_id: "",
                          arm_type: 0,
                          as_built_length: 330,
                          cable_diameter: null,
                          cable_length: 233.28488579,
                          cable_length_in_kilometers: null,
                          cable_length_source: "GIS LENGTH + SLACK LOOP LENGTH",
                          cable_manufacturer: "",
                          cable_marking_unit_of_measure: "",
                          cable_name: "",
                          cable_owner: "",
                          cable_twist_factor: 1,
                          cable_type: "",
                          cable_vendor: "",
                          channel: "",
                          colour_info: null,
                          comments: "",
                          construction_type: "Loose Tube",
                          contract_no: "",
                          core: 2,
                          creation_date: "2018-05-31T03:41:16Z",
                          creation_user: "osxsu021",
                          cust_type: "",
                          date_Commisioned: null,
                          date_installed: null,
                          date_modified: "2018-05-31T03:57:46Z",
                          description: "",
                          design_length: null,
                          diameter: 8,
                          district: "ฟขข.",
                          document_hot_link_path: "",
                          enabled: 1,
                          ending_cable_length_marking: null,
                          equipment_type: "",
                          est_mm_attenuation_1310: null,
                          est_mm_attenuation_850: null,
                          est_sm_attenuation_1310: 0.001,
                          est_sm_attenuation_1550: 0.001,
                          fiber_child_class_model_name: "BUFFERTUBE",
                          fiber_count: 2,
                          fiber_parent: "",
                          fiber_parent_class_model_name: "",
                          fiber_type: 1,
                          field_notes_length: null,
                          filling_info: "",
                          frequence: "",
                          geohash: "w4rw8x25yu",
                          glass_length: 233.28488579,
                          global_id: "{2EFF1A43-2904-4D06-A704-A8D000749874}",
                          helicity: null,
                          id_code: null,
                          infrastructure_class: "",
                          install_date: null,
                          installed_by: "",
                          last_user: "osxsu021",
                          leased_from: "",
                          leased_from_contract_expires_on: "",
                          leased_from_contract_information: "",
                          leased_from_contract_number: "",
                          leased_from_contract_person: "",
                          leased_to: "",
                          leased_to_contract_expires_on: "",
                          leased_to_contract_information: "",
                          leased_to_contract_number: "",
                          leased_to_contract_person: "",
                          location:
                            "สถานีย่อยเกษตร (KE) 77114453 M1 - 77080145 M2 ใกล้บ้านเลขที่ 23/23 ถึง ใกล้บ้านเลขที่ 88 บริษัท สิงห์แลนด์ จำกัด (มหาชน) ซอยงามวงศ์วาน 54 แยก 5",
                          manufacturer: "",
                          mic_code: "",
                          model_number: "2 Fiber (1x2)",
                          multi_mode_availability_qty: 0,
                          number_of_fibers: 2,
                          number_of_tubes: 1,
                          object_id: 286882,
                          option_expires_on_date: "",
                          option_to_use_indicator: "",
                          overhead_underground: "Overhead",
                          overlashed_indicator: null,
                          owner: "MEA",
                          percentage_of_fibers_available: null,
                          phase: null,
                          product_url: "",
                          project_state: "",
                          project_status: "",
                          proposed_fiber_optic_cable_ind: null,
                          reelid: "",
                          reference: "MEA_KE(AMR6) - MEA METER",
                          rent_exp: null,
                          rent_start: null,
                          renter: "",
                          restoration_instructions: "",
                          route_code: "",
                          route_precision: "",
                          segment_glass_length: 233.28488579,
                          segment_id: "",
                          segment_length: 233.28488579,
                          session_status: null,
                          sheath: "",
                          single_mode_availability_qty: 2,
                          starting_cable_length_marking: null,
                          status: "",
                          sub_type_id: 1,
                          tag: "ET0164300286882",
                          this_fiber_class_model_name: "SHEATH",
                          tracer_wire_indicator: null,
                          wo_no: "",
                          work_order_number: "",
                          work_type: "AMR",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/circuit-breakers/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "เซอร์กิตเบรคเกอร์",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.cb_id:MA17",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              act_voltage: {
                                type: "integer",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              bay_no: {
                                type: "integer",
                              },
                              cb_id: {
                                type: "string",
                              },
                              cb_status: {
                                type: "string",
                              },
                              circuit_source_id: {
                                type: "integer",
                              },
                              cont_rat: {
                                type: "integer",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "string",
                              },
                              enabled: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "integer",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              int_rat: {
                                type: "integer",
                              },
                              int_type: {
                                type: "string",
                              },
                              known_peak: {
                                type: "integer",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              manf: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              nom_voltage: {
                                type: "integer",
                              },
                              normal_position_a: {
                                type: "integer",
                              },
                              normal_position_b: {
                                type: "integer",
                              },
                              normal_position_c: {
                                type: "integer",
                              },
                              normal_status: {
                                type: "integer",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              pf: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              present_position_a: {
                                type: "integer",
                              },
                              present_position_b: {
                                type: "integer",
                              },
                              present_position_c: {
                                type: "integer",
                              },
                              radial: {
                                type: "string",
                              },
                              relate_sub_station_oid: {
                                type: "integer",
                              },
                              sn_status: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              sub_xfr_id: {
                                type: "string",
                              },
                              sub_xfr_oid: {
                                type: "string",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "Point",
                          coordinates: [100.59400128, 13.67600558],
                        },
                        properties: {
                          _id: "5eb00bcb75ffed8ab6b65000",
                          act_voltage: 0,
                          ancillary_role: 1,
                          bay_no: 0,
                          cb_id: "MA17",
                          cb_status: "O",
                          circuit_source_id: 1050,
                          cont_rat: 0,
                          creation_user: "",
                          date_created: null,
                          date_modified: "2015-08-21T06:44:27Z",
                          design_id: "",
                          design_text: "",
                          drawing_no: "",
                          electric_trace_weight: 79616,
                          enabled: 1,
                          estimate_id: "",
                          facility_id: "",
                          feeder_id: "MA17",
                          feeder_id2: "",
                          feeder_info: 7,
                          geohash: "w4rtc1dkd0",
                          indx_code: "CBOMO",
                          int_rat: 0,
                          int_type: "VCB",
                          known_peak: 12,
                          label_text: "MA17",
                          last_user: "esri5148",
                          manf: "MD",
                          name: "6",
                          nom_volt: "",
                          nom_voltage: 12000,
                          normal_position_a: null,
                          normal_position_b: null,
                          normal_position_c: null,
                          normal_status: 1,
                          object_id: 6,
                          ohug: "O",
                          op_volt: "M2",
                          op_volt_int: 12000,
                          pf: 0,
                          phase_designation: 7,
                          point_type: "CB",
                          present_position_a: null,
                          present_position_b: null,
                          present_position_c: null,
                          radial: "1",
                          relate_sub_station_oid: null,
                          sn_status: "Z",
                          sub_source: 0,
                          sub_type_code: 0,
                          sub_xfr_id: "MA",
                          sub_xfr_oid: "42222PKIS000838",
                          symbol_rotation: 258,
                          tag: "42222PKIS000840",
                          volt_class: "M",
                          wms_code: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/sl-inline-equipments/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "อุปกรณ์ประกอบสายไฟฟ้าสาธารณะ",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string",
              example: "properties.tag:78364PKIN000137",
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "string",
                              },
                              enabled: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              sn_status: {
                                type: "string",
                              },
                              source_id: {
                                type: "string",
                              },
                              source_id2: {
                                type: "string",
                              },
                              source_info: {
                                type: "integer",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        geometry: {
                          type: "Point",
                          coordinates: [100.92935059, 13.80636531],
                        },
                        properties: {
                          _id: "5eb00c2475ffed8ab6b65001",
                          ancillary_role: 0,
                          creation_user: "",
                          date_created: null,
                          date_modified: "2014-06-26T17:00:00Z",
                          design_id: "",
                          design_text: "",
                          drawing_no: "",
                          electric_trace_weight: 0,
                          enabled: 0,
                          estimate_id: "",
                          facility_id: "",
                          geohash: "w4ry89qebm",
                          indx_code: "INOSE",
                          label_text: " ",
                          last_user: "esri4918",
                          name: "1",
                          nom_volt: "",
                          object_id: 1,
                          ohug: "O",
                          op_volt: "Z",
                          op_volt_int: 230,
                          phase_designation: 7,
                          point_type: "IN",
                          sn_status: "Z",
                          source_id: "46034",
                          source_id2: "",
                          source_info: 7,
                          sub_type_code: 300,
                          symbol_rotation: 140,
                          tag: "78364PKIN000137",
                          volt_class: "S",
                          wms_code: "",
                          wo_id: "",
                          work_flow_status: null,
                          work_function: null,
                          work_location_id: "",
                          work_request_id: "",
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
    "/v1.0/collections/risers/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "เสาต้นขึ้นหัวสายเคเบิลใต้ดิน",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string"
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: "2"              
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              comments: {
                                type: "string",
                              },
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "string",
                              },
                              enabled: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "string",
                              },                                                                                          
                              geohash: {
                                type: "string",
                              },
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              mea_district_code_e: {
                                type: "string",
                              },
                              mea_district_code_t: {
                                type: "string",
                              },
                              mea_district_id: {
                                type: "integer",
                              },
                              mea_district_name_e: {
                                type: "string",
                              },
                              mea_district_name_t: {
                                type: "string",
                              },                                 
                              name: {
                                type: "string",
                              },
                              nom_volt: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              phase_designation: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              riser_id: {
                                type: "string",
                              },                              
                              sn_status: {
                                type: "string",
                              },
                              sub_type_code: {
                                type: "integer",
                              },
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "geometry": {
                                "type": "Point",
                                "coordinates": [
                                    100.49355691,
                                    13.74472826
                                ]
                            },
                            "properties": {
                                "_id": "606ae8e8cdeb8595f7777",
                                "ancillary_role": 0,
                                "comments": "",
                                "creation_user": "",
                                "date_created": null,
                                "date_modified": "2013-12-11T17:00:00Z",
                                "design_id": "",
                                "design_text": "",
                                "drawing_no": "",
                                "electric_trace_weight": 0,
                                "enabled": 1,
                                "estimate_id": "",
                                "facility_id": "",
                                "feeder_id": "WL13",
                                "feeder_id2": "WL26",
                                "feeder_info": 4231,
                                "geohash": "w4rqny1hve",
                                "indx_code": "RSOL",
                                "label_text": " ",
                                "last_user": "esri4801",
                                "mea_district_code_e": "WLD.",
                                "mea_district_code_t": "ฟขล.",
                                "mea_district_id": 66,
                                "mea_district_name_e": "Wat Liab District",
                                "mea_district_name_t": "การไฟฟ้าเขตวัดเลียบ",
                                "name": "22340",
                                "nom_volt": "",
                                "object_id": 22340,
                                "ohug": "O",
                                "op_volt": "Z",
                                "op_volt_int": 24000,
                                "phase_designation": 7,
                                "point_type": "RS",
                                "riser_id": " ",
                                "sn_status": "Z",
                                "sub_type_code": 242,
                                "symbol_rotation": 90,
                                "tag": "31294PKF0000179",
                                "ter_type": "",
                                "volt_class": "Z",
                                "wms_code": "",
                                "wo_id": "",
                                "work_flow_status": null,
                                "work_function": null,
                                "work_location_id": "",
                                "work_request_id": ""
                            }
                        }
                    ]
                  }
                },
              },
            },
          },
        },
      },
    }, 
    "/v1.0/collections/sub-transformers/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "หม้อแปลงไฟฟ้าย่อย",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string"
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: "2"              
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",
                              },
                              ancillary_role: {
                                type: "integer",
                              },
                              base_capacity: {
                                type: "integer",
                              },
                              bay_no: {
                                type: "integer",
                              },
                              connections: {
                                type: "string",
                              },                              
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_inst: {
                                type: "string",
                                format: "date-time",
                              },                              
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              },
                              drawing_no: {
                                type: "string",
                              },
                              electric_trace_weight: {
                                type: "string",
                              },
                              enabled: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },
                              facility_id: {
                                type: "string",
                              },
                              feeder_id: {
                                type: "string",
                              },
                              feeder_id2: {
                                type: "string",
                              },
                              feeder_info: {
                                type: "string",
                              },                                                                                          
                              geohash: {
                                type: "string",
                              },
                              hi_volt: {
                                type: "integer",
                              },                              
                              indx_code: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              lo_volt: {
                                type: "integer",
                              },   
                              manf: {
                                type: "string",
                              },                                                           
                              mea_district_code_e: {
                                type: "string",
                              },
                              mea_district_code_t: {
                                type: "string",
                              },
                              mea_district_id: {
                                type: "integer",
                              },
                              mea_district_name_e: {
                                type: "string",
                              },
                              mea_district_name_t: {
                                type: "string",
                              },                                 
                              mva_fa: {
                                type: "integer",
                              },
                              mva_oa: {
                                type: "integer",
                              },                              
                              name: {
                                type: "string",
                              },
                              no_load_cur: {
                                type: "integer",
                              }, 
                              no_load_loss: {
                                type: "integer",
                              }, 
                              no_load_volt: {
                                type: "integer",
                              },                                                                                           
                              nom_volt: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              ohug: {
                                type: "string",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              percent_imped: {
                                type: "integer",
                              },                              
                              phase_designation: {
                                type: "integer",
                              },
                              point_type: {
                                type: "string",
                              },
                              pos_r: {
                                type: "integer",
                              },
                              pos_x: {
                                type: "integer",
                              },                                                            
                              shr_cir_loss: {
                                type: "string",
                              }, 
                              shr_circuit: {
                                type: "string",
                              },                                                            
                              sn_status: {
                                type: "string",
                              },
                              sub_tran_no: {
                                type: "integer",
                              },                              
                              sub_type_code: {
                                type: "integer",
                              },
                              sub_xfr_id: {
                                type: "string",
                              },                              
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },
                              tab: {
                                type: "string",
                              },                              
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              },
                              zero_r: {
                                type: "integer",
                              },  
                              zero_x: {
                                type: "integer",
                              },                                                            
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "geometry": {
                                "type": "Point",
                                "coordinates": [
                                    100.80318508,
                                    13.81410258
                                ]
                            },
                            "properties": {
                                "_id": "606aee0c80c3ba7657366666",
                                "ancillary_role": 0,
                                "base_capacity": 0,
                                "bay_no": 1,
                                "connections": "Z",
                                "creation_user": "",
                                "date_created": null,
                                "date_inst": null,
                                "date_modified": "2004-11-17T17:00:00Z",
                                "design_id": "",
                                "design_text": "",
                                "drawing_no": "",
                                "electric_trace_weight": 0,
                                "enabled": 1,
                                "estimate_id": "",
                                "facility_id": "",
                                "feeder_id": "",
                                "feeder_id2": "",
                                "feeder_info": 8,
                                "geohash": "w4rwtff8ur",
                                "hi_volt": 115000,
                                "indx_code": "SBOH1",
                                "label_text": " ",
                                "last_user": "2142133",
                                "lo_volt": 0,
                                "manf": "Z",
                                "mea_district_code_e": "MBD.",
                                "mea_district_code_t": "ฟขม.",
                                "mea_district_id": 79,
                                "mea_district_name_e": "Min Buri District",
                                "mea_district_name_t": "การไฟฟ้าเขตมีนบุรี",
                                "mva_fa": 0,
                                "mva_oa": 0,
                                "name": "1",
                                "no_load_cur": null,
                                "no_load_loss": null,
                                "no_load_volt": null,
                                "nom_volt": "",
                                "object_id": 1,
                                "ohug": "O",
                                "op_volt": "H1",
                                "op_volt_int": 115000,
                                "percent_imped": 0,
                                "phase_designation": 7,
                                "point_type": "SB",
                                "pos_r": 0,
                                "pos_x": 0,
                                "shr_cir_loss": null,
                                "shr_circuit": null,
                                "sn_status": "Z",
                                "sub_tran_no": " ",
                                "sub_type_code": 103,
                                "sub_xfr_id": "NJT",
                                "symbol_rotation": 99,
                                "tag": "050000000712479",
                                "tap": "",
                                "volt_class": "H",
                                "wms_code": "",
                                "work_flow_status": null,
                                "work_function": null,
                                "work_location_id": "",
                                "work_request_id": "",
                                "zero_r": 0,
                                "zero_x": 0
                            }
                        }
                    ]
                  }
                },
              },
            },
          },
        },
      },
    },   
    "/v1.0/collections/switchgears/items": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สวิตช์เกียร์",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string"
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: "2"              
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              _id: {
                                type: "string",                            
                              },
                              comments: {
                                type: "string",
                              },                              
                              creation_user: {
                                type: "string",
                              },
                              date_created: {
                                type: "string",
                                format: "date-time",
                              },
                              date_inst: {
                                type: "string",
                                format: "date-time",
                              },                              
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              design_id: {
                                type: "string",
                              },
                              design_text: {
                                type: "string",
                              }, 
                              district_id: {
                                type: "string",
                              },                                                           
                              drawing_no: {
                                type: "string",
                              },
                              estimate_id: {
                                type: "string",
                              },                                                                          
                              geohash: {
                                type: "string",
                              },
                              in_feed_no: {
                                type: "integer",
                              },                              
                              in_type: {
                                type: "string",
                              },
                              label_text: {
                                type: "string",
                              },
                              last_user: {
                                type: "string",
                              },
                              manf: {
                                type: "string",
                              },                                                           
                              mea_district_code_e: {
                                type: "string",
                              },
                              mea_district_code_t: {
                                type: "string",
                              },
                              mea_district_id: {
                                type: "integer",
                              },
                              mea_district_name_e: {
                                type: "string",
                              },
                              mea_district_name_t: {
                                type: "string",
                              },                                                              
                              name: {
                                type: "string",
                              },
                              object_id: {
                                type: "integer",
                              },
                              op_volt: {
                                type: "string",
                              },
                              op_volt_int: {
                                type: "integer",
                              },
                              out_feed_no: {
                                type: "integer",
                              }, 
                              out_type: {
                                type: "string",
                              },  
                              owner: {
                                type: "string",
                              },                                                                                                                      
                              sub_type_code: {
                                type: "integer",
                              },
                              swgr_id: {
                                type: "string",
                              },                              
                              symbol_rotation: {
                                type: "integer",
                                format: "double",
                              },
                              tag: {
                                type: "string",
                              },                              
                              volt_class: {
                                type: "string",
                              },
                              wms_code: {
                                type: "string",
                              },
                              wo_id: {
                                type: "string",
                              },                              
                              work_flow_status: {
                                type: "integer",
                              },
                              work_function: {
                                type: "integer",
                              },
                              work_location_id: {
                                type: "string",
                              },
                              work_request_id: {
                                type: "string",
                              }                                                           
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "geometry": {
                                "type": "Point",
                                "coordinates": [
                                    100.66184023,
                                    13.54361321
                                ]
                            },
                            "properties": {
                                "_id": "606afa9ecc366cb10bb33333",
                                "comments": "",
                                "creation_user": "",
                                "date_created": null,
                                "date_inst": null,
                                "date_modified": null,
                                "design_id": "",
                                "design_text": "",
                                "district_id": "",
                                "drawing_no": "",
                                "estimate_id": "",
                                "geohash": "w4rt49e9qb",
                                "in_feed_no": 0,
                                "in_type": "Z",
                                "label_text": " ",
                                "last_user": " ",
                                "manf": "Z",
                                "mea_district_code_e": "SPD.",
                                "mea_district_code_t": "ฟขป.",
                                "mea_district_id": 77,
                                "mea_district_name_e": "Samut Prakarn District",
                                "mea_district_name_t": "การไฟฟ้าเขตสมุทรปราการ",
                                "name": "1",
                                "object_id": 1,
                                "op_volt": "M2",
                                "op_volt_int": 12000,
                                "out_feed_no": 0,
                                "out_type": "Z",
                                "owner": "Z",
                                "sub_type_code": 251,
                                "swgr_id": " ",
                                "symbol_rotation": 423,
                                "tag": "50073PKFS000036",
                                "volt_class": "S",
                                "wms_code": "",
                                "wo_id": "",
                                "work_flow_status": null,
                                "work_function": null,
                                "work_location_id": "",
                                "work_request_id": ""
                            }
                        }
                    ]
                  }
                },
              },
            },
          },
        },
      },
    },  
    "/special/fiber-optic-privates": {
      get: {
        tags: ["ข้อมูลระบบไฟฟ้า"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "สายสื่อสารเฉพาะบุคคลภายใน",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "filter",
            description:
              "กรองข้อมูลเพื่อเรียกดูเฉพาะข้อมูลที่สนใจ รูปแบบของ filter = {properties}.{Key}:{value}\n",
            schema: {
              type: "string"
            },
          },
          {
            in: "query",
            name: "bbox",
            description:
              "กำหนด Bounding Box เพื่อกรองข้อมูลที่อยู่ในกรอบพื้นที่ที่ต้องการ [Bounding Box](http://bboxfinder.com/)\n",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "limit",
            description: "จำกัดจำนวนผลลัพธ์ของข้อมูล",
            schema: {
              type: "integer",
              example: "2"              
            },
          },
          {
            in: "query",
            name: "offset",
            description: "จำนวนของข้อมูลที่จะข้าม",
            schema: {
              type: "integer",
            },
          },
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  properties: {
                    type: {
                      type: "string",
                    },
                    features: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          type: {
                            type: "string",
                            description: "ชนิดของข้อมูล",
                          },
                          geometry: {
                            type: "object",
                            properties: {
                              type: {
                                type: "string",
                                description: "ชนิดของฟีเจอร์",
                              },
                              coordinates: {
                                type: "array",
                                description: "พิกัด",
                                items: {
                                  type: "integer",
                                },
                              },
                            },
                          },
                          properties: {
                            type: "object",
                            properties: {
                              tag: {
                                type: "string",
                              },
                              creation_date: {
                                type: "string",
                                format: "date-time",
                              },
                              date_modified: {
                                type: "string",
                                format: "date-time",
                              },
                              as_build_length: {
                                type: "integer",
                              },
                              model_number: {
                                type: "string",
                              },
                              number_of_tubes: {
                                type: "integer",
                              },
                              number_of_fibers: {
                                type: "integer",
                              },
                              core: {
                                type: "integer",
                              }                                                          
                            },
                          },
                        },
                      },
                    },
                  },
                  example: {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "geometry": {
                                "type": "LineString",
                                "coordinates": [
                                    [
                                        100.59374296,
                                        13.92025088
                                    ],
                                    [
                                        100.59385718,
                                        13.92022126
                                    ],
                                    [
                                        100.59401621,
                                        13.92018846
                                    ],
                                    [
                                        100.59418219,
                                        13.92014722
                                    ],
                                    [
                                        100.59438713,
                                        13.9200939
                                    ],
                                    [
                                        100.59442081,
                                        13.92008508
                                    ],
                                    [
                                        100.59461535,
                                        13.92003513
                                    ],
                                    [
                                        100.59474438,
                                        13.92000354
                                    ],
                                    [
                                        100.59484048,
                                        13.91997765
                                    ],
                                    [
                                        100.59510221,
                                        13.91991116
                                    ],
                                    [
                                        100.59514611,
                                        13.91990015
                                    ],
                                    [
                                        100.59542094,
                                        13.91982981
                                    ],
                                    [
                                        100.59545623,
                                        13.91982134
                                    ]
                                ]
                            },
                            "properties": {
                                "tag": "ET0164300272381",
                                "creation_date": "2018-02-12T09:39:00Z",
                                "date_modified": "2018-02-13T03:29:26Z",
                                "as_build_length": 0,
                                "model_number": "24 Fiber (4x6)",
                                "number_of_tubes": 4,
                                "number_of_fibers": 24,
                                "core": 24
                            }
                        }
                    ]
                  }
                },
              },
            },
          },
        },
      },
    },  
    "/v1.0/premiums/nearest-low-voltage-meters": {
      get: {
        tags: ["Premium Service"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "มิเตอร์ไฟฟ้าแรงต่ำที่ใกล้ที่สุด",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            "required" : true,
            name: "lat",
            description:"ละติจูด",
            schema: {
              type: "string"
            },
          },
          {
            in: "query",
            "required" : true,
            name: "lon",
            description:"ลองจิจูด",
            schema: {
              type: "string"
            },
          },          
          {
            in: "query",
            name: "AMPS_ALLOW",
            description:
              "AMPS_ALLOW",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "OP_VOLT",
            description: "OP_VOLT",
            schema: {
              type: "integer",            
            },
          },
          {
            in: "query",
            name: "SUBTYPECODE",
            description: "subtype code",
            schema: {
              type: "integer",
            },
          },
          {
            in: "query",
            name: "meters",
            description: "ระยะห่างจากมิเตอร์ไฟฟ้าแรงต่ำ (เมตร)",
            schema: {
              type: "integer",
            },
          }          
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "array",
                  items: {  
                    type: "object",
                    properties: {
                      METER_NO10: {
                        type: "string",
                      },
                      AMPS_ALLOW: {
                        type: "string",
                      },
                      OP_VOLT: {
                        type: "string",
                      },
                      x: {
                        type: "number",
                        format:"double"
                      },
                      y: {
                        type: "number",
                        format:"double"
                      }                                             
                    }                   
                  },               
                  example: [
                    {
                        "METER_NO10": "<meter no10>",
                        "AMPS_ALLOW": "5",
                        "OP_VOLT": "L2",
                        "x": 100.59302118,
                        "y": 13.88351521
                    }
                ]
                },
              },
            },
          },
        },
      },
    }, 
    "/v1.0/premiums/nearest-high-tension-meters": {
      get: {
        tags: ["Premium Service"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "high tension meter ที่ใกล้ที่สุด",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            "required" : true,
            name: "lat",
            description:"ละติจูด",
            schema: {
              type: "string"
            },
          },
          {
            in: "query",
            "required" : true,
            name: "lon",
            description:"ลองจิจูด",
            schema: {
              type: "string"
            },
          },          
          {
            in: "query",
            name: "CONNECT_KVA",
            description:
              "CONNECT_KVA",
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "OP_VOLT",
            description: "OP_VOLT",
            schema: {
              type: "integer",            
            },
          },
          {
            in: "query",
            name: "meters",
            description: "ระยะห่างจาก high tension meter (เมตร)",
            schema: {
              type: "integer",
            },
          }          
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                  type: "array",
                  items: {  
                    type: "object",
                    properties: {
                      METER_NO10: {
                        type: "string",
                      },
                      CONNECT_KVA: {
                        type: "string",
                      },
                      OP_VOLT: {
                        type: "string",
                      },
                      x: {
                        type: "number",
                        format:"double"
                      },
                      y: {
                        type: "number",
                        format:"double"
                      }                                             
                    }                   
                  },               
                  example: [
                    {
                        "METER_NO10": "<meter no10>",
                        "CONNECT_KVA": 400,
                        "OP_VOLT": "M1",
                        "x": 100.59266768,
                        "y": 13.88361576
                    }
                ]
                },
              },
            },
          },
        },
      },
    }, 
    "/v1.0/premiums/mea-districts": {
      get: {
        tags: ["Premium Service"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "ค้นหาเขตการไฟฟ้านครหลวง",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            "required" : true,
            name: "lat",
            description:"ละติจูด",
            schema: {
              type: "string"
            },
          },
          {
            in: "query",
            "required" : true,
            name: "lon",
            description:"ลองจิจูด",
            schema: {
              type: "string"
            },
          }  
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                    type: "object",
                    properties: {

                      ID_CODE: {
                        type: "number"
                      },
                      NAME_CODE_E: {
                        type: "string",
                      },
                      NAME_CODE_T: {
                        type: "string",
                      },
                      NAME_E: {
                        type: "string",
                      },                                            
                    },
                    NAME_T: {
                      type: "string",
                    },                                                                                  
                  },               
                  example: {
                    "ID_CODE": 80,
                    "NAME_CODE_E": "BHD.",
                    "NAME_CODE_T": "ฟขข.",
                    "NAME_E": "Bang Khen District",
                    "NAME_T": "การไฟฟ้าเขตบางเขน"
                }
              },
            },
          },
        },
      },
    }, 
    "/v1.0/premiums/administratives": {
      get: {
        tags: ["Premium Service"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "ค้นหาข้อมูลขอบเขตการปกครอง",
        parameters: [
          {
            in: "query",
            //"required" : true,
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            "required" : true,
            name: "lat",
            description:"ละติจูด",
            schema: {
              type: "string"
            },
          },
          {
            in: "query",
            "required" : true,
            name: "lon",
            description:"ลองจิจูด",
            schema: {
              type: "string"
            },
          }  
        ],
        responses: {
          200: {
            description: "ผลลัพธ์ตัวอย่าง",
            content: {
              "application/json": {
                schema: {
                    type: "object",
                    properties: {

                      PROV_NAMT: {
                        type: "number"
                      },
                      PROV_NAME: {
                        type: "string",
                      },
                      AMP_NAMT: {
                        type: "string",
                      },
                      AMP_NAMTE: {
                        type: "string",
                      },                                            
                    },
                    NAME_T: {
                      type: "string",
                    },                                                                                  
                  },               
                  example: {
                    "PROV_NAMT": "นนทบุรี",
                    "PROV_NAME": "NONTHABURI",
                    "AMP_NAMT": "เมืองนนทบุรี",
                    "AMP_NAME": "MUEANG NONTHABURI",
                    "TAM_NAMT": "บางเขน",
                    "TAM_NAME": "BANG KHEN"
                  }
              },
            },
          },
        },
      },
    },                                
  },
  components: {
    securitySchemes: {
      ApiKeyAuth: {
        type: "apiKey",
        in: "query",
        name: "api_key",
        description: "API Key for Authorization api",
      },
    },
  },
};
